var _defs, _g, _path, _g2, _g3, _text, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _path12, _circle2, _circle3, _path13, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAraclar13(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 437.62 270.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);}.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-110,.cls-112,.cls-113,.cls-115,.cls-117,.cls-118,.cls-12,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-130,.cls-132,.cls-135,.cls-137,.cls-139,.cls-14,.cls-140,.cls-141,.cls-16,.cls-18,.cls-2,.cls-20,.cls-21,.cls-23,.cls-25,.cls-27,.cls-29,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-4,.cls-40,.cls-41,.cls-42,.cls-43,.cls-48,.cls-50,.cls-51,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-6,.cls-60,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-68,.cls-70,.cls-71,.cls-72,.cls-73,.cls-75,.cls-76,.cls-78,.cls-79,.cls-8,.cls-80,.cls-82,.cls-84,.cls-85,.cls-87,.cls-89,.cls-91,.cls-93,.cls-94,.cls-98,.cls-99{fill-rule:evenodd;}.cls-10,.cls-12,.cls-14,.cls-16,.cls-18,.cls-2,.cls-20,.cls-21,.cls-23,.cls-25,.cls-27,.cls-29,.cls-4,.cls-6,.cls-8{mix-blend-mode:multiply;}.cls-2{fill:url(#linear-gradient);}.cls-3{mask:url(#mask-2);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{mask:url(#mask-3);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{mask:url(#mask-4);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{mask:url(#mask-5);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{mask:url(#mask-6);}.cls-12{fill:url(#linear-gradient-6);}.cls-13{mask:url(#mask-7);}.cls-14{fill:url(#linear-gradient-7);}.cls-15{mask:url(#mask-8);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{mask:url(#mask-9);}.cls-18{fill:url(#linear-gradient-9);}.cls-19{mask:url(#mask-10);}.cls-20{fill:url(#linear-gradient-10);}.cls-21{fill:url(#linear-gradient-11);}.cls-22{mask:url(#mask-12);}.cls-23{fill:url(#linear-gradient-12);}.cls-24{mask:url(#mask-13);}.cls-25{fill:url(#linear-gradient-13);}.cls-26{mask:url(#mask-14);}.cls-27{fill:url(#linear-gradient-14);}.cls-28{mask:url(#mask-15);}.cls-29{fill:url(#linear-gradient-15);}.cls-30,.cls-34{fill:#afb4ba;}.cls-30{clip-rule:evenodd;}.cls-31{fill:#606a71;}.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-113,.cls-148,.cls-32,.cls-46,.cls-73,.cls-85,.cls-99{fill:#fff;}.cls-33{fill:#bbc2c6;}.cls-35{fill:#8e979a;}.cls-36,.cls-44,.cls-76,.cls-79,.cls-80{fill:#010101;}.cls-37{fill:#333;}.cls-38{fill:#3c454d;}.cls-38,.cls-39,.cls-73,.cls-79{opacity:0.5;}.cls-39{fill:url(#New_Gradient_93);}.cls-128,.cls-40{fill:#3f4143;}.cls-41{fill:#989898;}.cls-119,.cls-42{fill:#676767;}.cls-43{fill:#ccc;}.cls-45{fill:url(#New_Gradient_84);}.cls-47{fill:#ed2224;}.cls-48{fill:url(#New_Gradient_83);}.cls-49{fill:url(#linear-gradient-16);}.cls-50{fill:url(#linear-gradient-17);}.cls-51{fill:url(#New_Gradient_82);}.cls-122,.cls-52{fill:#535a5d;}.cls-53{fill:#d0d6d9;}.cls-54{fill:#657379;}.cls-55{fill:#e6e6e5;}.cls-56{fill:url(#linear-gradient-18);}.cls-57{fill:url(#linear-gradient-19);}.cls-58{fill:url(#New_Gradient_91);}.cls-133,.cls-59{fill:#4e4e4e;}.cls-60{fill:#818181;}.cls-61{fill:#1a1a1a;}.cls-62{fill:url(#New_Gradient_89);}.cls-63{fill:#545d60;}.cls-64{fill:url(#New_Gradient_87);}.cls-65{fill:#bfbdac;}.cls-66{fill:#1f1a18;}.cls-67{fill:url(#New_Gradient_84-2);}.cls-68{fill:url(#New_Gradient_83-2);}.cls-69{fill:url(#linear-gradient-20);}.cls-70{fill:url(#linear-gradient-21);}.cls-71{fill:url(#New_Gradient_82-2);}.cls-72{fill:#3e9bd5;}.cls-74{mask:url(#mask-16);}.cls-75{fill:url(#linear-gradient-22);}.cls-76{opacity:0.15;}.cls-77{mask:url(#mask-17);}.cls-78{fill:url(#linear-gradient-23);}.cls-80,.cls-85{opacity:0.2;}.cls-81{mask:url(#mask-18);}.cls-82{fill:url(#linear-gradient-24);}.cls-83{mask:url(#mask-19);}.cls-84{fill:url(#linear-gradient-25);}.cls-86{mask:url(#mask-20);}.cls-87{fill:url(#linear-gradient-26);}.cls-88{mask:url(#mask-21);}.cls-89{fill:url(#linear-gradient-27);}.cls-90{mask:url(#mask-22);}.cls-91{fill:url(#linear-gradient-28);}.cls-92{mask:url(#mask-23);}.cls-93{fill:url(#linear-gradient-29);}.cls-94{fill:#dbe2e9;}.cls-95{mask:url(#mask-24);}.cls-96{fill:url(#linear-gradient-30);}.cls-97{mask:url(#mask-25);}.cls-98{fill:url(#linear-gradient-31);}.cls-99{opacity:0;}.cls-100{opacity:0.1;}.cls-101{opacity:0.2;}.cls-102{opacity:0.3;}.cls-103{opacity:0.4;}.cls-104{opacity:0.5;}.cls-105{opacity:0.6;}.cls-106{opacity:0.7;}.cls-107{opacity:0.8;}.cls-108{opacity:0.9;}.cls-109{mask:url(#mask-26);}.cls-110{fill:url(#linear-gradient-32);}.cls-111{mask:url(#mask-27);}.cls-112{fill:url(#linear-gradient-33);}.cls-113{opacity:0.8;}.cls-114{mask:url(#mask-28);}.cls-115{fill:url(#linear-gradient-34);}.cls-116{mask:url(#mask-29);}.cls-117{fill:url(#linear-gradient-35);}.cls-118{fill:#cdd3d7;}.cls-120{fill:#b4b4b4;}.cls-121{fill:#edf5f7;}.cls-123{fill:#7d888f;}.cls-124{fill:#98a5ab;}.cls-125{fill:#c6d1d4;}.cls-126{fill:url(#linear-gradient-36);}.cls-127,.cls-131{fill:#9a1b1f;}.cls-129{mask:url(#mask-30);}.cls-130{fill:url(#linear-gradient-37);}.cls-132{fill:#686a6b;}.cls-134{fill:url(#New_Gradient_81);}.cls-135{fill:url(#New_Gradient_80);}.cls-136{fill:url(#New_Gradient_79);}.cls-137{fill:#3f4045;}.cls-138{clip-path:url(#clip-path);}.cls-139{fill:#6d767d;}.cls-140{fill:url(#New_Gradient_78);}.cls-141{fill:#f16263;}.cls-142{font-size:11.68px;letter-spacing:-0.14em;}.cls-142,.cls-148{font-family:Biko-Bold, Biko;font-weight:700;}.cls-143{letter-spacing:-0.06em;}.cls-144{letter-spacing:-0.1em;}.cls-145{letter-spacing:-0.08em;}.cls-146{fill:none;}.cls-147{fill:#231f20;}.cls-148{font-size:11.87px;letter-spacing:-0.08em;}.cls-149{filter:url(#luminosity-noclip-15);}.cls-150{filter:url(#luminosity-noclip-14);}.cls-151{filter:url(#luminosity-noclip-13);}.cls-152{filter:url(#luminosity-noclip-12);}.cls-153{filter:url(#luminosity-noclip-10);}.cls-154{filter:url(#luminosity-noclip-9);}.cls-155{filter:url(#luminosity-noclip-8);}.cls-156{filter:url(#luminosity-noclip-7);}.cls-157{filter:url(#luminosity-noclip-6);}.cls-158{filter:url(#luminosity-noclip-5);}.cls-159{filter:url(#luminosity-noclip-4);}.cls-160{filter:url(#luminosity-noclip-3);}.cls-161{filter:url(#luminosity-noclip-2);}.cls-162{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 254.46,
    y: -10104.63,
    width: 18.13,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 254.46,
    y: -10104.63,
    width: 18.13,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 263.52,
    y1: 156.79,
    x2: 263.52,
    y2: 127.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e4e4e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 167.79,
    y: -10104.63,
    width: 44.92,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 167.79,
    y: -10104.63,
    width: 44.92,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 190.25,
    y1: 172.98,
    x2: 190.25,
    y2: 190.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#818181"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 187.87,
    y: -10104.63,
    width: 91.85,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 187.87,
    y: -10104.63,
    width: 91.85,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 233.8,
    y1: 198.48,
    x2: 233.8,
    y2: 174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818181"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 274.15,
    y: -10104.63,
    width: 37.38,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 274.15,
    y: -10104.63,
    width: 37.38,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 287.8,
    y1: 155.52,
    x2: 298.05,
    y2: 165.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 173.64,
    y: -10104.63,
    width: 106.01,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 173.64,
    y: -10104.63,
    width: 106.01,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-158"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 226.64,
    y1: 199.3,
    x2: 226.64,
    y2: 174.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 259.21,
    y: -10104.63,
    width: 12.7,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 259.21,
    y: -10104.63,
    width: 12.7,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-157"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 265.56,
    y1: 142.75,
    x2: 265.56,
    y2: 179.05,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-7",
    x: 110.75,
    y: -10104.63,
    width: 95.58,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 110.75,
    y: -10104.63,
    width: 95.58,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 110.75,
    y1: 151.87,
    x2: 206.33,
    y2: 151.87,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-8",
    x: 245.51,
    y: -10104.63,
    width: 19.92,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 245.51,
    y: -10104.63,
    width: 19.92,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-155"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 255.47,
    y1: 88.29,
    x2: 255.47,
    y2: 99.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-9",
    x: 257.73,
    y: -10104.63,
    width: 53.75,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 257.73,
    y: -10104.63,
    width: 53.75,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 290.39,
    y1: 123.34,
    x2: 279.29,
    y2: 142.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-10",
    x: 261.76,
    y: -10104.63,
    width: 38.17,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: 261.76,
    y: -10104.63,
    width: 38.17,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 261.76,
    y1: 123.02,
    x2: 299.93,
    y2: 123.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 261.76,
    y1: 122.95,
    x2: 299.93,
    y2: 122.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818181"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-12",
    x: 109.98,
    y: -10104.63,
    width: 15.89,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    x: 109.98,
    y: -10104.63,
    width: 15.89,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-152"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 117.93,
    y1: 132.65,
    x2: 117.93,
    y2: 138.13,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-13",
    x: 190.64,
    y: -10104.63,
    width: 28.87,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    x: 190.64,
    y: -10104.63,
    width: 28.87,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 219.51,
    y1: 151.52,
    x2: 190.64,
    y2: 151.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-14",
    x: 125.27,
    y: -10104.63,
    width: 68.73,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    x: 125.27,
    y: -10104.63,
    width: 68.73,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-150"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 125.27,
    y1: 136.17,
    x2: 194,
    y2: 136.17,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-15",
    x: 168.91,
    y: -10104.63,
    width: 50.77,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    x: 168.91,
    y: -10104.63,
    width: 50.77,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-149"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 219.68,
    y1: 181.06,
    x2: 168.91,
    y2: 181.06,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_93",
    x1: -258.77,
    y1: 532.21,
    x2: -258.77,
    y2: 516.84,
    gradientTransform: "translate(524.73 -426.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#a3a7ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#d3d7de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#a3a7ad"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_84",
    cx: 75.89,
    cy: 805.94,
    r: 16.99,
    gradientTransform: "translate(57.26 -603.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#cdd3d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#cdd3d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#d0d6d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_83",
    x1: -153.48,
    y1: 361.53,
    x2: -190.2,
    y2: 406.87,
    gradientTransform: "translate(304.29 -180.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#37383a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1e1e22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -127.96,
    y1: 404.61,
    x2: -170.91,
    y2: 444.66,
    gradientTransform: "translate(281.79 -221.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e7980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#242629"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -172.79,
    y1: 403.74,
    x2: -146.42,
    y2: 364.66,
    gradientTransform: "translate(291.99 -180.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#515a61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282c2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_82",
    x1: -164.61,
    y1: 401.84,
    x2: -142.56,
    y2: 366.56,
    gradientTransform: "translate(285.97 -180.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#657379"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -461.93,
    y1: 1247.85,
    x2: -445.69,
    y2: 1254.08,
    gradientTransform: "translate(596.27 -1076.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#4e4e4e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -135.64,
    y1: 419.18,
    x2: -119.74,
    y2: 424.35,
    gradientTransform: "translate(270.17 -247.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_91",
    x1: -121.5,
    y1: 450.99,
    x2: -111.78,
    y2: 426.95,
    gradientTransform: "translate(277.28 -261.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_89",
    cx: 4629.07,
    cy: -857.05,
    r: 12.17,
    gradientTransform: "translate(732.37 3215.36) rotate(-90) scale(0.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_87",
    x1: -311.83,
    y1: 400.9,
    x2: -324.05,
    y2: 423.87,
    gradientTransform: "translate(629.35 -209.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#89887a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d3d6c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#c3c7ae"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_84-2",
    cx: -134.06,
    cy: 805.94,
    r: 16.99,
    gradientTransform: "translate(446.26 -603.07)",
    xlinkHref: "#New_Gradient_84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_83-2",
    x1: -363.44,
    y1: 361.53,
    x2: -400.16,
    y2: 406.87,
    gradientTransform: "translate(693.29 -180.76)",
    xlinkHref: "#New_Gradient_83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -337.91,
    y1: 404.61,
    x2: -380.86,
    y2: 444.66,
    gradientTransform: "translate(670.8 -221.17)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -382.74,
    y1: 403.74,
    x2: -356.38,
    y2: 364.65,
    gradientTransform: "translate(680.99 -180.76)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_82-2",
    x1: -374.56,
    y1: 401.84,
    x2: -352.51,
    y2: 366.56,
    gradientTransform: "translate(674.97 -180.76)",
    xlinkHref: "#New_Gradient_82"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    x: 254.46,
    y: 127.3,
    width: 18.13,
    height: 29.49,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.46,127.3l.3.61,2,.07,4.69.12c1.65.28,3,1.48,4.25,3.33l2.37,3.91,2,3.87,1.29,3.13.58,1.67.21,1.64-.21,2.09-.39,2.67-.49,2.88-.46,2.73a2.66,2.66,0,0,1-.35.77,3.18,3.18,0,0,0,.81-1.36l.46-2.73.49-2.88.39-2.67.21-2.09-.21-1.64-.58-1.67-1.29-3.13-2-3.87-2.37-3.9c-1.21-1.85-2.59-3.06-4.25-3.34l-4.69-.12-2.73-.09Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 263.52,
    y1: 156.79,
    x2: 263.52,
    y2: 127.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    x: 110.75,
    y: 131.29,
    width: 95.58,
    height: 41.15,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M110.75,134.74c1.18-.86,5.21-3,16.5-3.42,14.21-.54,42.74,5.76,54,14.22s25.1,26.9,25.1,26.9l-.55-.07c-7-4.66-24.16-18-31.13-23-7.78-5.55-21.61-7.77-45.94-10.8-9.29-1.16-14.76-2.55-18-3.83Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 110.75,
    y1: 151.87,
    x2: 206.33,
    y2: 151.87,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    x: 190.64,
    y: 149.41,
    width: 28.87,
    height: 4.21,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M204.94,150.48c8-1,14.5-1.37,14.57-.8s-6.33,1.87-14.3,2.88-14.49,1.36-14.57.79S197,151.49,204.94,150.48Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 219.51,
    y1: 151.52,
    x2: 190.64,
    y2: 151.52,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-19",
    x: 125.27,
    y: 123.49,
    width: 68.73,
    height: 25.34,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M125.27,129.9l3.07-6.27a.37.37,0,0,1,0-.14c5.8,1,20.31,3.7,31.4,6.26,14.18,3.26,28.19,9.19,32.23,10.83s.94,2.14,0,3.61.08,2.66-.69,4.29-6.62-2.66-14.95-7c-8-4.23-30.8-8.54-51.07-11.54Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 125.27,
    y1: 136.17,
    x2: 194,
    y2: 136.17,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    x: 168.91,
    y: 171.23,
    width: 50.77,
    height: 19.67,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M169,175.44s4-3.57,14.57-1.91,19.91,7.82,23.86,11.13a38.39,38.39,0,0,1,6,6.24l6.17-1-11.32-15.4-2.1-2.1s-9.65-.66-19.34-1-19.24-.4-17.88,4.07Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 219.68,
    y1: 181.06,
    x2: 168.91,
    y2: 181.06,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-21",
    x: 167.79,
    y: 172.98,
    width: 44.92,
    height: 17.51,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.68,174.85a2.92,2.92,0,0,0-.63,3.2,88.2,88.2,0,0,0,5.37,7.42l2.05-2.49s.38-1.34,2.35-.95,15.74,3.59,15.74,3.59l2.16-.58,12.87,3.11,1.39,1.68,2.72.67s-3-6.51-16.31-12.45-21.06-6.17-27.71-3.2Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 190.25,
    y1: 172.98,
    x2: 190.25,
    y2: 190.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    x: 187.87,
    y: 174,
    width: 91.85,
    height: 24.48,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188.71,186.49s12.39,2.94,17.64,3.88a254.8,254.8,0,0,0,30.54,4c15.75,1.16,21,4.2,28.14-2.73S276.47,174,276.47,174l3.25.42s-7.56,16-13.54,20.26S263,199,243.4,197.83c-7.26-.43-18.43-1-27.5-2.32-15.46-2.26-28-5.55-28-5.55l.84-3.47Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 233.8,
    y1: 198.48,
    x2: 233.8,
    y2: 174,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    x: 274.15,
    y: 148.49,
    width: 37.38,
    height: 28.17,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M274.15,169.17l2.63,5.19,9.16,2.24s2.05.65,2.61-2.34,5.42-11.3,9.34-14.38,5.88-2.71,7.75-2.89,5.89-7.57,5.89-7.57l-.07-.1a33.93,33.93,0,0,1-7.34-.83s-1.48,5.58-3,7.39-5.5,4.33-7.55,7.23-3.37,5-6.78,6.86-11.65-.6-11.65-.6l-1-.2Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 287.8,
    y1: 155.52,
    x2: 298.05,
    y2: 165.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    x: 173.64,
    y: 174.24,
    width: 106.01,
    height: 25.06,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M213.12,191.72v-.1l-1.75-.43,1.75.53Zm-1.83-.56Zm0-.19,1.79.44a24,24,0,0,0-3.06-.84c.17.22.66.25,1.27.4Zm-33.67-6.41,1.8-.11a6.47,6.47,0,0,0-1.8.11Zm-4,2.44v0s1.88-3.45,4.31-3.47,14.47,3,15,2.93c1.64-.13.34-1.19,4.93-.06,2.16.54,10,1.87,11.43,3.17l.62.84a22.94,22.94,0,0,0,7.12,1l2.59,0,0-.06c.9.15,4.34.11,4.85-.8l.06-.14,0,0c0,.26,0,.28.1.43,3.94.18,19.58.61,22.14.28l4-1c1.47-.93,6.35-10.34,8-11.4,7.61-4.82,8.38-4.26,16.9-4.6a19.7,19.7,0,0,1,3.78.65v0l0,0v0h0a54.68,54.68,0,0,1-4.46,9.68c-1.86,3.42-5,6.63-7.84,9.32s-1.71,1.72-5.26,4h0c-2.52,1.69-11.08,1.3-14.11,1.12-8.15-.51-17.32-1.27-25.47-2-9.67-.85-14-1.94-23.39-4.16l-2.85-.68h0s-13.07-3.18-16.38-3.42c-.86-.06-5.48-1-5.52-1h0l-.15-.16h0l-.56-.69h0l0,0Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 226.64,
    y1: 199.3,
    x2: 226.64,
    y2: 174.24,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-25",
    x: 259.21,
    y: 142.75,
    width: 12.7,
    height: 36.3,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M259.21,179.05s2-6.25,2.11-10.69c0-1.35.22-3.33.46-5.52l5.88-3.56c-.23,1.28-.43,2.68-.69,4.34-.81,5.15-.91,7.26-1.61,9.88s-5.15,3.43-6.15,5.55Zm2.65-17c.52-4.83,1.17-10.45.77-12.84a36.81,36.81,0,0,1-.6-4.64,7.22,7.22,0,0,1,6.15-1.71c3.93.6,4.84,4.33,2.32,8.67a21.24,21.24,0,0,0-2.68,6.92l-6,3.6Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 265.56,
    y1: 142.75,
    x2: 265.56,
    y2: 179.05,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    x: 245.51,
    y: 88.29,
    width: 19.92,
    height: 11.61,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M245.51,91.8a10.14,10.14,0,0,1,1.25-.77L248,88.29l15.45,1.83.05,1-2.08,1.73s-1.12,2.13.71,3.4a11.41,11.41,0,0,1,3.28,3.54,10.12,10.12,0,0,1-1.83.09c-4.64-.15-2.67-2.2-9.12-6a14.37,14.37,0,0,0-9-2.08Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 255.47,
    y1: 88.29,
    x2: 255.47,
    y2: 99.9,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-27",
    x: 257.73,
    y: 111.6,
    width: 53.75,
    height: 37.84,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M268.75,111.6l-5.84.18a12.07,12.07,0,0,0-1.56,3.47c-.32,1.74-.47,1.9-1.58,2.06a16.36,16.36,0,0,1-2,.06,2.66,2.66,0,0,0,.84,1.33c1.1,1.1,12.72,15.82,17.68,22.11,3.24,1.84,7.25,3.83,10,4.24,5.32.8,15.54,2.86,18.24,3.49,1.6.38,5.06,1.15,7,.81l-9.57-14.5-2.06-.56.1-1.68s-7.66-10.18-31.2-21Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 290.39,
    y1: 123.34,
    x2: 279.29,
    y2: 142.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    x: 261.76,
    y: 111.8,
    width: 38.17,
    height: 22.44,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M264.48,111.8l-1.61,0-1.11.52a18,18,0,0,1,4.43,1c1.9.83,20.67,13,20.67,13s6.88,4.83,8.16,5.7,2.86,2.53,4.84,2.13l.07-1.22c-.52.15-1.59-.08-3.83-1.63-3.4-2.36-23.47-16.41-31.62-19.53Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 261.76,
    y1: 123.02,
    x2: 299.93,
    y2: 123.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-29",
    x: 261.76,
    y: 111.73,
    width: 38.17,
    height: 22.44,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M264.48,111.73l-1.61.06-1.11.52a18,18,0,0,1,4.43,1c1.9.82,20.67,13,20.67,13s6.88,4.82,8.16,5.7,2.86,2.53,4.84,2.13l.07-1.22c-.52.15-1.59-.08-3.83-1.63-3.4-2.36-23.47-16.41-31.62-19.54Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 261.76,
    y1: 122.95,
    x2: 299.93,
    y2: 122.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 118,
    y1: 141.87,
    x2: 118,
    y2: 133.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#9a1b1f"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    x: 109.98,
    y: 132.65,
    width: 15.89,
    height: 5.49,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M125.86,138.13h0s-2.4-3.74-5.35-4.66-3.26-.81-3.26-.81L110,135.09c4.39,1.38,12.42,2.57,15.88,3Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 117.93,
    y1: 132.65,
    x2: 117.93,
    y2: 138.13,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_81",
    x1: -279.21,
    y1: 429.84,
    x2: -286.55,
    y2: 429.84,
    gradientTransform: "translate(421.23 -296.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_80",
    x1: -100.73,
    y1: 471.64,
    x2: -114.16,
    y2: 471.64,
    gradientTransform: "translate(229 -341.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_79",
    x1: -257.45,
    y1: 487.1,
    x2: -257.45,
    y2: 493.8,
    gradientTransform: "translate(498.58 -420.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#818181"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M278.22,131.28s5.54,4.67,7.5,6.56,4.87,5.75,5.68,6.62a8,8,0,0,0,3.89,1.83c1.37.27,7.92,1.15,7.92,1.15s-16-18.33-25-16.16Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_78",
    x1: -794.6,
    y1: -270.62,
    x2: -817.67,
    y2: -276.37,
    gradientTransform: "translate(664.71 290.15) scale(0.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#9a1b1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010101"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chassis"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spot"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M260.8,100.6h3.65A.6.6,0,0,0,265,100V92.44a.6.6,0,0,0-.59-.59H260.8a.59.59,0,0,0-.59.59V100a.59.59,0,0,0,.59.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M261.41,94.9c-.09-1.24,1.39-2.22,3.29-2.2h.17v4.46c-1.84-.07-3.38-1.07-3.46-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M264.87,97.17a4.5,4.5,0,0,1-2.73-1l1.22.26a3.73,3.73,0,0,0,1.51.08v.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M264.87,95.42a21.38,21.38,0,0,1-2.14-.38c-.52-.17-.55-.28-.26-.71s1.48-.4,1.41-.16-.68.53.36.63l.63.07v.55Zm0-1.46c-.65-.08-1-.11-.84-.19s.37-.13-.43-.26a2.87,2.87,0,0,0-1.4.11,2.15,2.15,0,0,1,1.38-.6c.23,0,.7,0,1.29,0v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M264.87,93.59a7.07,7.07,0,0,0-1.6,0s-.1-.37.61-.49a5.14,5.14,0,0,1,1,0v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M260.45,94.29c0-.33.15-.59.39-.58a.59.59,0,0,1,.49.58c0,.33-.15.58-.39.58a.59.59,0,0,1-.49-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M264,92.39a3.25,3.25,0,0,1,.92.06v.14a3.56,3.56,0,0,1-.7.1,2.14,2.14,0,0,1-1-.11c-.06-.08.3-.17.79-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M263.08,90.33s5,1.72,6.39,5.52.76,11.36.76,11.36-7-2.23-9-8.52.51-7.69,1.88-8.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M263.08,90.33s5,1.72,6.39,5.52c1,2.74.93,7.44.84,9.85a29.8,29.8,0,0,0-2.12-10c-1.44-3.12-4.77-4.08-6.62-4.37a5.15,5.15,0,0,1,1.51-1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M263.81,110.42l-12.74,7.16s-7.21-4.92-10.91-9.08-4.47-6.3-4.57-8.48-.1-3.5.91-3.56,1.37,0,1.37,0l8.33-5.73,1.42-2.44,15.84,1.88.05,1-2.08,1.73s-1.12,2.13.71,3.4a11.68,11.68,0,0,1,4.26,5.59,8,8,0,0,0,2.59,3.9c.91.82,1.63,1.43,1.63,1.43l-4.22,1.26s-2.79-.1-2.59,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M243.49,95.65s-5.67,1.22-6.66,3.82-.94,5.51,4.22,5.51a112.57,112.57,0,0,0,12.2-1s.87-6.45-9.76-8.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M243.85,103.81a13.11,13.11,0,0,1,3.75.2,26.6,26.6,0,0,1-7.49.13A13.89,13.89,0,0,1,243.85,103.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M244.74,100.9a3.61,3.61,0,0,0-7.21,0,2.86,2.86,0,0,0,0,.42,1.78,1.78,0,0,0-.11.65,1.88,1.88,0,0,0,1.59,1.86,3.61,3.61,0,0,0,5.7-2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M244.35,100.9a3.21,3.21,0,0,0-5.67-2.07,3.24,3.24,0,0,1,2.08-.76,3.22,3.22,0,0,1,2.45,5.28,3.23,3.23,0,0,0,1.14-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M240.92,102a1.6,1.6,0,0,0-2.82-1,1.61,1.61,0,0,1,2.47,1.35,1.58,1.58,0,0,1-.39,1,1.58,1.58,0,0,0,.74-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M248.79,100.6c1,0,1.89.54,1.89,1.21s-.85,1.21-1.89,1.21-1.88-.54-1.88-1.21S247.75,100.6,248.79,100.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M247.51,102a1.11,1.11,0,0,1,1.53-.41,1.12,1.12,0,0,1-1.12,1.94A1.11,1.11,0,0,1,247.51,102Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M248.29,102a.48.48,0,0,1,.65-.17.47.47,0,0,1,.17.64.47.47,0,0,1-.82-.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 251.82,
    y: 112.86,
    width: 12.77,
    height: 2.9,
    transform: "matrix(0.86, -0.5, 0.5, 0.86, -22.47, 145.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M136.5,186l-2.93-.06a13.32,13.32,0,0,1,1.42,9.14,7.57,7.57,0,0,1-.68,2.05,1.83,1.83,0,0,1-1,1,.87.87,0,0,1-.75-.14h0a23.86,23.86,0,0,0-7.23-3.43,20.68,20.68,0,0,0-8.22-.53l-1,2.77a13.38,13.38,0,0,1,9.13,1.47,7.54,7.54,0,0,1,1.74,1.28,1.92,1.92,0,0,1,.66,1.26.86.86,0,0,1-.37.67,23.9,23.9,0,0,0-5.5,5.82,20.53,20.53,0,0,0-3,7.64l2.34,1.77a13.31,13.31,0,0,1,4.22-8.22,7.77,7.77,0,0,1,1.75-1.26,1.88,1.88,0,0,1,1.41-.24.86.86,0,0,1,.52.56,24,24,0,0,0,3.83,7,20.62,20.62,0,0,0,6.34,5.25l2.4-1.67a13.38,13.38,0,0,1-6.52-6.56,8,8,0,0,1-.66-2.06,1.93,1.93,0,0,1,.21-1.4h0a.86.86,0,0,1,.7-.33,24.19,24.19,0,0,0,7.87-1.47,20.75,20.75,0,0,0,6.95-4.41l-.85-2.8a13.29,13.29,0,0,1-8.25,4.17,7.34,7.34,0,0,1-2.16,0,1.87,1.87,0,0,1-1.27-.63h0a.86.86,0,0,1-.09-.76h0a24,24,0,0,0,1-7.94,20.67,20.67,0,0,0-2-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M135.09,186h-.74a11.1,11.1,0,0,1,1.47,6c-.28,3.74.61,5.8-2,6.86s-3.41,2.12-.78,3.63c2.32,1.33,4.51,1.31,4.47,0a.92.92,0,0,1,0-.29,1.72,1.72,0,0,0-.08-.28c-.73-1.84-.67-1.95-.62-4.57.05-2.2.06-9-1.67-11.36ZM149.86,201l-.39-1.3a11.76,11.76,0,0,1-3.22,2.17c-4.11,1.94-6.64,3.38-2.2,2.06,3.13-.93,4.53-1.65,5.81-2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M134.2,185.68h.67l.22.26h-.74a2,2,0,0,0-.15-.26Zm15.48,13.84.39,1.28-.21.22-.39-1.29.21-.21Zm-12.18,2.93a1,1,0,0,0,0-.29.92.92,0,0,0,0,.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M161.62,203.44a29.18,29.18,0,1,0-29.18,29.17,29.17,29.17,0,0,0,29.18-29.17Zm-12.65,0A16.53,16.53,0,1,0,132.44,220,16.53,16.53,0,0,0,149,203.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M151.26,184.84l3.07,2.28c-1.35.2-.75,0-2.25.94l0-.18-1.94-2.24,1.07-.82v0Zm7.37,14.87,1.1,3.66c-1.2-.64-.6-.46-2.37-.58l.15-.12-.23-3,1.34,0v0ZM148.3,182.25l3.37,1.81c-1.3.39-.74.1-2.08,1.26v-.19l-2.25-1.93.94-1Zm-37.1,5.27,1.81-3.37c.39,1.31.09.75,1.25,2.09l-.18,0-1.93,2.26-1-.94,0,0Zm42.37,31.84-1.8,3.37c-.4-1.31-.1-.75-1.26-2.09l.18,0,1.93-2.26,1,.94,0,0Zm-4.49,8.06,3.15-2.69c-1.8,2.08-1.12,1.34-3.83,3.28l.68-.59Zm4.75-5.5a3.52,3.52,0,0,1-.59,1.26h0c-.85,1.45-2.06,2.23-3.57,3.56a56,56,0,0,0,4.15-4.82Zm.07-2.08c.61,1.64-.05,1.65-2.5,4.84a33.29,33.29,0,0,1,2.5-4.84Zm-38.21-40.39-3.14,2.7c1.79-2.08,1.11-1.35,3.82-3.28l-.68.58ZM110.94,185a3.45,3.45,0,0,1,.59-1.26h0c.85-1.46,2.06-2.24,3.57-3.56a54.57,54.57,0,0,0-4.15,4.82Zm-.07,2.08c-.61-1.64,0-1.65,2.5-4.84a32.33,32.33,0,0,1-2.5,4.84Zm5.6,37.59-3.37-1.81c1.3-.39.74-.1,2.08-1.26v.19l2.25,1.93-.94,1Zm-8.07-4.5,2.7,3.15c-2.08-1.79-1.35-1.11-3.28-3.83l.58.68Zm5.5,4.75a3.63,3.63,0,0,1-1.25-.58h0c-1.46-.84-2.24-2.06-3.57-3.57a57.6,57.6,0,0,0,4.82,4.15ZM116,225c-1.65.61-1.66,0-4.84-2.5A33.29,33.29,0,0,1,116,225Zm40.38-38.21-2.69-3.14c2.07,1.79,1.34,1.11,3.28,3.83l-.59-.69Zm-5.5-4.75a3.85,3.85,0,0,1,1.25.59h0c1.45.84,2.23,2.06,3.56,3.56a59.53,59.53,0,0,0-4.82-4.15Zm-2.09-.06c1.65-.61,1.66,0,4.84,2.5a33.29,33.29,0,0,1-4.84-2.5Zm-20.12-4.73,3.66-1.1c-.65,1.2-.46.59-.59,2.36l-.12-.14-3,.23,0-1.34Zm7.45,52.48-3.66,1.1c.65-1.2.46-.6.59-2.36l.11.14,3-.23,0,1.34Zm-8.88,2.53,4.13.31c-2.74.2-1.74.17-5-.38l.9.07Zm7.25-.54a3.61,3.61,0,0,1-1.3.48h0c-1.63.43-3,.12-5,0a56.18,56.18,0,0,0,6.34-.48Zm1.52-1.43c-.73,1.6-1.2,1.14-5.19,1.66a35.05,35.05,0,0,1,5.19-1.66Zm1.54-55.57-4.13-.31c2.74-.2,1.74-.17,5,.38l-.9-.07Zm-7.25.54a3.68,3.68,0,0,1,1.3-.48h0c1.63-.43,3-.12,5,0a56.35,56.35,0,0,0-6.34.48Zm-1.52,1.42c.73-1.59,1.2-1.14,5.19-1.65a33.91,33.91,0,0,1-5.19,1.65Zm-22.62,30.53L105,203.5c1.2.65.6.46,2.37.59l-.14.12.23,3-1.35,0v0Zm-2.53-8.88-.32,4.13c-.2-2.73-.16-1.73.39-5l-.07.89Zm.53,7.26a3.72,3.72,0,0,1-.47-1.31h0c-.44-1.62-.13-3,0-5a56.34,56.34,0,0,0,.47,6.35Zm1.43,1.51c-1.59-.72-1.14-1.2-1.66-5.18a32.39,32.39,0,0,1,1.66,5.18Zm55.57,1.54.32-4.13c.2,2.74.16,1.74-.39,5l.07-.9Zm-.53-7.25a3.72,3.72,0,0,1,.47,1.31h0c.44,1.62.13,3,0,5a56.34,56.34,0,0,0-.47-6.35Zm-1.43-1.52c1.59.73,1.14,1.21,1.66,5.19a32.19,32.19,0,0,1-1.66-5.19Zm-1.48-4.2,1.66,3.43c-1.28-.45-.66-.36-2.42-.2l.12-.14-.7-2.89,1.33-.23v0Zm-13-15.62,3.61,1.25c-1.23.6-.72.22-1.86,1.58l0-.19L144,181.09l.78-1.1ZM109,191.07l1.25-3.61c.6,1.22.22.72,1.57,1.86h-.18L110,191.86l-1.1-.77v0Zm46.87,24.74-1.25,3.61c-.59-1.23-.21-.72-1.57-1.86h.18l1.55-2.53,1.1.77v0Zm-3.16,8.68,2.68-3.16c-1.44,2.33-.88,1.5-3.26,3.84l.58-.68Zm3.82-6.19a3.66,3.66,0,0,1-.38,1.33h0c-.61,1.57-1.69,2.54-3,4.09a54.75,54.75,0,0,0,3.34-5.42Zm-.26-2.07c.86,1.53.21,1.64-1.7,5.18a31.61,31.61,0,0,1,1.7-5.18ZM112.11,182.4l-2.68,3.15c1.44-2.33.89-1.5,3.26-3.84l-.58.69Zm-3.82,6.18a3.47,3.47,0,0,1,.38-1.33h0c.6-1.57,1.68-2.53,3-4.08a54.75,54.75,0,0,0-3.34,5.42Zm.26,2.07c-.86-1.53-.21-1.65,1.71-5.18a33,33,0,0,1-1.71,5.18ZM120,226.88l-3.61-1.26c1.23-.59.73-.21,1.86-1.57l0,.19,2.53,1.55-.77,1.1Zm-8.67-3.16,3.16,2.67c-2.34-1.44-1.51-.88-3.84-3.26l.68.59Zm6.18,3.81a3.69,3.69,0,0,1-1.33-.37h0c-1.57-.6-2.53-1.68-4.08-3a54.51,54.51,0,0,0,5.41,3.33Zm2.07-.26c-1.52.86-1.64.22-5.17-1.7a33.54,33.54,0,0,1,5.17,1.7Zm33.84-44.11-3.16-2.68c2.34,1.45,1.51.89,3.85,3.26l-.69-.58Zm-6.18-3.82a3.66,3.66,0,0,1,1.33.38h0c1.57.6,2.53,1.68,4.08,3a56.55,56.55,0,0,0-5.41-3.34Zm-2.07.27c1.52-.87,1.64-.22,5.17,1.7a33.54,33.54,0,0,1-5.17-1.7Zm-20.62-1.49,3.44-1.67c-.45,1.29-.36.66-.2,2.43l-.14-.12-2.89.69-.23-1.32Zm15.65,50.64-3.44,1.67c.45-1.29.36-.66.21-2.43l.13.12,2.89-.69.23,1.32Zm-8.37,3.9,4.13-.34c-2.67.63-1.69.44-5,.41l.89-.07Zm7.08-1.68a3.58,3.58,0,0,1-1.21.68h0c-1.54.69-3,.61-5,.8a55.15,55.15,0,0,0,6.19-1.48Zm1.27-1.64c-.47,1.69-1,1.31-4.86,2.45a32.45,32.45,0,0,1,4.86-2.45Zm-7.26-55.12-4.13.34c2.68-.63,1.69-.44,5-.41l-.9.07Zm-7.07,1.67a3.64,3.64,0,0,1,1.21-.67h0c1.53-.69,3-.61,5-.8a57.2,57.2,0,0,0-6.18,1.47Zm-1.28,1.65c.47-1.69,1-1.31,4.86-2.45a32,32,0,0,1-4.86,2.45Zm-17.51,33.72-1.67-3.44c1.29.45.66.36,2.42.21l-.12.14.7,2.89-1.33.23v0Zm-3.9-8.36.33,4.12c-.63-2.67-.43-1.69-.41-5l.08.9Zm1.67,7.07a3.47,3.47,0,0,1-.67-1.21h0c-.68-1.54-.6-3-.79-5a55.1,55.1,0,0,0,1.47,6.19Zm1.65,1.27c-1.69-.46-1.32-1-2.46-4.86a34,34,0,0,1,2.46,4.86ZM161.6,204l-.34-4.12c.63,2.67.44,1.69.42,5l-.08-.9Zm-1.67-7.07a3.49,3.49,0,0,1,.68,1.21h0c.68,1.54.6,3,.79,5a55.1,55.1,0,0,0-1.47-6.19Zm-1.65-1.28c1.69.47,1.32,1,2.46,4.86a33,33,0,0,1-2.46-4.86Zm-2.11-3.87,2.19,3.13c-1.34-.24-.71-.25-2.43.18l.1-.16-1.14-2.74,1.27-.43v0ZM141,178.36l3.76.67c-1.12.78-.68.32-1.59,1.84l-.05-.18-2.74-1.13.59-1.21ZM107.3,194.88l.68-3.76c.78,1.12.32.68,1.84,1.59l-.18,0-1.14,2.74-1.2-.59v0ZM157.47,212l-.68,3.76c-.77-1.12-.32-.68-1.84-1.59l.18,0,1.14-2.75,1.2.6v0Zm-1.77,9.06,2.15-3.54c-1.06,2.53-.64,1.63-2.62,4.31l.47-.77Zm2.81-6.71a3.69,3.69,0,0,1-.17,1.38h0c-.35,1.65-1.26,2.76-2.28,4.49a55,55,0,0,0,2.45-5.87Zm-.59-2c1.09,1.38.47,1.59-.87,5.38a33.23,33.23,0,0,1,.87-5.38Zm-48.85-26.53-2.15,3.54c1.06-2.54.64-1.63,2.62-4.31l-.47.77Zm-2.8,6.7a3.46,3.46,0,0,1,.16-1.37h0c.35-1.65,1.26-2.77,2.28-4.5a54.6,54.6,0,0,0-2.44,5.87Zm.58,2c-1.09-1.37-.47-1.58.87-5.37a33.11,33.11,0,0,1-.87,5.37Zm17,34-3.76-.67c1.12-.78.68-.33,1.6-1.85l0,.19,2.74,1.13-.59,1.21Zm-9.06-1.77,3.54,2.16c-2.53-1.07-1.62-.65-4.3-2.63l.76.47Zm6.71,2.81a3.5,3.5,0,0,1-1.38-.17h0c-1.64-.35-2.76-1.27-4.49-2.29a55.88,55.88,0,0,0,5.87,2.45Zm2-.58c-1.37,1.09-1.59.47-5.37-.88a32.27,32.27,0,0,1,5.37.88ZM150,180.13,146.47,178c2.53,1.06,1.62.64,4.3,2.62l-.77-.46Zm-6.7-2.81a3.68,3.68,0,0,1,1.38.16h0c1.64.35,2.76,1.27,4.49,2.29a55.88,55.88,0,0,0-5.87-2.45Zm-2,.58c1.37-1.09,1.59-.47,5.38.87a32.16,32.16,0,0,1-5.38-.87Zm-20.6,1.75,3.14-2.18c-.24,1.34-.25.71.18,2.43l-.16-.1-2.74,1.14-.44-1.28Zm23.37,47.58-3.14,2.18c.24-1.34.25-.71-.17-2.43l.15.1,2.74-1.14.44,1.27,0,0Zm-7.66,5.16,4-1c-2.55,1-1.6.7-4.9,1.2l.87-.21Zm6.73-2.76a3.52,3.52,0,0,1-1.1.85h0c-1.41.91-2.85,1.06-4.8,1.56a56.91,56.91,0,0,0,5.89-2.42Zm1-1.83c-.2,1.74-.79,1.46-4.42,3.18a33.57,33.57,0,0,1,4.42-3.18Zm-15.78-53.31-4,1c2.54-1,1.6-.69,4.89-1.19l-.87.21Zm-6.73,2.76a3.56,3.56,0,0,1,1.09-.85h0c1.41-.91,2.85-1.06,4.8-1.56a56.91,56.91,0,0,0-5.89,2.42Zm-1,1.83c.2-1.74.79-1.46,4.42-3.19a32.72,32.72,0,0,1-4.42,3.19Zm-12,36L106.41,212c1.35.24.71.25,2.43-.18l-.1.16,1.14,2.74-1.27.43v0Zm-5.16-7.66,1,4c-1-2.54-.7-1.6-1.19-4.9l.21.87Zm2.76,6.73a3.47,3.47,0,0,1-.86-1.09h0c-.92-1.41-1.06-2.85-1.56-4.79a55.47,55.47,0,0,0,2.42,5.88Zm1.83,1c-1.75-.19-1.46-.79-3.19-4.41a32.61,32.61,0,0,1,3.19,4.41Zm53.3-15.78-1-4c1,2.54.7,1.6,1.19,4.9l-.21-.88Zm-2.76-6.72a3.47,3.47,0,0,1,.86,1.09h0c.92,1.41,1.06,2.84,1.56,4.79a52.65,52.65,0,0,0-2.42-5.88Zm-1.82-1c1.74.19,1.45.79,3.18,4.41a32.32,32.32,0,0,1-3.18-4.41ZM154,188.12l2.66,2.75c-1.37,0-.74-.13-2.37.56l.07-.17-1.56-2.53,1.19-.63v0Zm-17.16-10.8,3.82.06c-1,1-.62.43-1.28,2.08l-.07-.18-2.89-.68.4-1.29ZM106.26,199l.07-3.83c1,1,.43.63,2.07,1.28l-.17.07-.69,2.89-1.28-.39v0Zm52.25,8.92-.07,3.82c-.94-1-.43-.62-2.07-1.28l.17-.07.69-2.88,1.28.39v0Zm-.3,9.23,1.56-3.84c-.65,2.67-.38,1.71-1.91,4.67l.35-.83Zm1.7-7.07a3.57,3.57,0,0,1,.05,1.39h0c-.09,1.68-.81,2.93-1.55,4.8a54.67,54.67,0,0,0,1.49-6.19Zm-.9-1.88c1.3,1.18.72,1.49,0,5.44a34.05,34.05,0,0,1,0-5.44Zm-52.44-18.43L105,193.58c.65-2.66.38-1.7,1.91-4.66l-.34.83Zm-1.71,7.07a3.59,3.59,0,0,1,0-1.39h0c.08-1.68.8-2.93,1.54-4.8a54.67,54.67,0,0,0-1.49,6.19Zm.9,1.88c-1.3-1.18-.72-1.49,0-5.45a33,33,0,0,1,0,5.45Zm22.16,30.86-3.82-.06c1-.95.62-.43,1.28-2.08l.07.18,2.89.68-.39,1.29Zm-9.22-.3,3.83,1.56c-2.67-.64-1.7-.37-4.67-1.9l.84.34Zm7.06,1.7a3.53,3.53,0,0,1-1.38.06h0c-1.68-.08-2.93-.81-4.8-1.54a56.69,56.69,0,0,0,6.18,1.48Zm1.89-.89c-1.19,1.29-1.5.72-5.45,0a33.08,33.08,0,0,1,5.45,0Zm18.42-52.45-3.83-1.56c2.67.64,1.71.37,4.67,1.9l-.84-.34ZM139,175.91a3.53,3.53,0,0,1,1.38,0h0c1.68.08,2.93.81,4.8,1.54a56.17,56.17,0,0,0-6.18-1.49Zm-1.88.9c1.17-1.3,1.49-.72,5.44,0a33,33,0,0,1-5.44,0Zm-20.06,5,2.75-2.65c0,1.36-.14.74.56,2.37l-.17-.08L117.68,183l-.63-1.18,0,0Zm30.63,43.26L145,227.72c0-1.36.14-.74-.56-2.37l.17.07,2.53-1.55.63,1.18,0,0ZM141,231.38l3.82-1.61c-2.35,1.43-1.47.94-4.65,1.95l.83-.34Zm6.21-3.8a3.52,3.52,0,0,1-.95,1h0c-1.25,1.13-2.65,1.49-4.49,2.3a57.22,57.22,0,0,0,5.43-3.33Zm.69-2c.08,1.75-.55,1.57-3.85,3.85a32.54,32.54,0,0,1,3.85-3.85ZM123.81,175.5,120,177.11c2.35-1.43,1.47-.94,4.65-2l-.83.35Zm-6.2,3.79a3.45,3.45,0,0,1,.94-1h0c1.24-1.13,2.64-1.5,4.48-2.3a57.78,57.78,0,0,0-5.42,3.32Zm-.7,2c-.09-1.75.55-1.56,3.85-3.85a32.54,32.54,0,0,1-3.85,3.85Zm-6.15,37.5L108.1,216c1.37,0,.74.13,2.37-.57l-.07.18,1.56,2.52-1.19.63ZM104.45,212l1.61,3.81c-1.43-2.34-.94-1.47-2-4.64l.35.83Zm3.79,6.2a3.62,3.62,0,0,1-1-.94h0c-1.13-1.25-1.5-2.64-2.3-4.48a53.85,53.85,0,0,0,3.32,5.42Zm2,.7c-1.76.08-1.57-.55-3.85-3.86a34.24,34.24,0,0,1,3.85,3.86Zm50.11-24.06-1.6-3.82c1.43,2.35.94,1.48,1.95,4.65l-.35-.83Zm-3.79-6.2a3.62,3.62,0,0,1,1,.94h0c1.13,1.25,1.5,2.64,2.3,4.48a53.85,53.85,0,0,0-3.32-5.42Zm-2-.7c1.75-.08,1.56.55,3.84,3.86a33.36,33.36,0,0,1-3.84-3.86Zm-22-11,3.79-.55c-.82,1.09-.55.52-.93,2.25l-.1-.16-3-.21.18-1.33Zm-26.7,26.3-.55-3.78c1.1.82.53.54,2.26.93l-.16.1-.21,3-1.34-.19v0Zm53,.4.55,3.78c-1.1-.82-.53-.54-2.25-.93l.15-.1.21-3,1.34.18v0Zm1.18,9.15.93-4c-.21,2.73-.1,1.74-1.13,4.91l.2-.88Zm.55-7.25a3.79,3.79,0,0,1,.27,1.36h0c.18,1.67-.33,3-.75,5a58.59,58.59,0,0,0,.47-6.35Zm-1.19-1.71c1.47,1,.95,1.36.87,5.37a32.91,32.91,0,0,1-.87-5.37Zm-54.73-9.74-.93,4c.21-2.73.1-1.74,1.13-4.91l-.2.88Zm-.55,7.25a3.74,3.74,0,0,1-.27-1.36h0c-.19-1.68.33-3,.76-5a56.18,56.18,0,0,0-.48,6.35Zm1.19,1.71c-1.47-1-1-1.36-.87-5.38a33,33,0,0,1,.87,5.38Zm26.85,26.89-3.78.55c.81-1.09.54-.52.92-2.25l.1.16,3,.21-.18,1.33ZM123,231.13l4,.92c-2.74-.21-1.74-.09-4.91-1.12l.87.2Zm7.25.54a3.55,3.55,0,0,1-1.36.28h0c-1.67.19-3-.33-5-.75a55.82,55.82,0,0,0,6.34.47Zm1.71-1.19c-1,1.47-1.35,1-5.37.88a33.08,33.08,0,0,1,5.37-.88Zm9.75-54.73-4-.92c2.74.21,1.74.09,4.91,1.12l-.87-.2Zm-7.25-.54a3.55,3.55,0,0,1,1.36-.28h0c1.67-.19,3,.32,5,.75a55.82,55.82,0,0,0-6.34-.47Zm-1.71,1.19c.95-1.47,1.35-1,5.37-.88a33.08,33.08,0,0,1-5.37.88Zm-19,8.16,2.28-3.06c.2,1.35,0,.75.94,2.25l-.18-.05-2.25,2-.81-1.07,0,0ZM151,222.32l-2.28,3.06c-.2-1.35,0-.75-.94-2.25l.18.05,2.25-2,.81,1.07,0,0Zm-5.63,7.31,3.51-2.2c-2.08,1.79-1.3,1.16-4.27,2.68l.76-.48Zm5.51-4.74a3.42,3.42,0,0,1-.77,1.15h0c-1,1.32-2.37,1.9-4.06,3a55.8,55.8,0,0,0,4.82-4.15Zm.37-2c.37,1.71-.29,1.63-3.18,4.42a32.42,32.42,0,0,1,3.18-4.42Zm-31.81-45.59-3.51,2.2c2.09-1.79,1.3-1.17,4.27-2.68l-.76.48ZM113.91,182a3.69,3.69,0,0,1,.76-1.16h0c1-1.31,2.37-1.91,4.06-3a55.8,55.8,0,0,0-4.82,4.15Zm-.37,2c-.36-1.72.29-1.63,3.18-4.42a31.59,31.59,0,0,1-3.18,4.42Zm0,38-3.07-2.29c1.35-.19.76,0,2.25-.93l0,.18,1.94,2.24-1.07.82v0Zm-7.31-5.64,2.2,3.51c-1.79-2.08-1.17-1.3-2.68-4.27l.48.76Zm4.74,5.51a3.43,3.43,0,0,1-1.16-.76h0c-1.31-1.05-1.9-2.36-3-4.05a54.32,54.32,0,0,0,4.16,4.81Zm2,.38c-1.72.36-1.64-.29-4.42-3.19a33.15,33.15,0,0,1,4.42,3.19Zm45.59-31.82-2.2-3.5c1.79,2.08,1.16,1.3,2.67,4.27l-.47-.77ZM153.83,185a3.62,3.62,0,0,1,1.16.77h0c1.32,1.05,1.91,2.36,3,4.05a55.92,55.92,0,0,0-4.16-4.82Zm-2-.37c1.71-.36,1.63.29,4.41,3.19a32.44,32.44,0,0,1-4.41-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M156,203.44A23.58,23.58,0,1,0,132.38,227,23.58,23.58,0,0,0,156,203.44Zm-5,0A18.58,18.58,0,1,0,132.38,222,18.57,18.57,0,0,0,151,203.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M153.19,203.44a20.8,20.8,0,1,0-20.81,20.8,20.81,20.81,0,0,0,20.81-20.8Zm-4.32,0a16.49,16.49,0,1,0-16.49,16.48,16.48,16.48,0,0,0,16.49-16.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M150.37,203.44a18,18,0,1,0-5.27,12.72,17.9,17.9,0,0,0,5.27-12.72Zm-4.8-13.18a18.65,18.65,0,1,1-13.19-5.46,18.58,18.58,0,0,1,13.19,5.46Zm3,13.18a16.15,16.15,0,1,0-4.73,11.42,16.15,16.15,0,0,0,4.73-11.42Zm-4.27-11.89a16.82,16.82,0,1,1-11.89-4.92,16.79,16.79,0,0,1,11.89,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M150.7,203.44a18.32,18.32,0,1,0-18.32,18.31,18.32,18.32,0,0,0,18.32-18.31Zm-1.83,0a16.49,16.49,0,1,0-16.49,16.48,16.48,16.48,0,0,0,16.49-16.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M137.87,203.44a5.49,5.49,0,1,1-5.49-5.49A5.49,5.49,0,0,1,137.87,203.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M153.19,204c0-.09,0-.18,0-.27a20.8,20.8,0,0,1-41.59,0V204a20.8,20.8,0,1,0,41.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M153.19,203.44c0,.09,0,.18,0,.28a20.8,20.8,0,0,0-41.59,0v-.28a20.8,20.8,0,1,1,41.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M184,204.49l-.09-1-.47-.28.42-.36,0-.59,3.4-1.12-1.48-1.55c-6,1.29-12.54,2.77-18.56,4h0l-5.46,1.17a1.93,1.93,0,0,1-.1.88h-.1a4.82,4.82,0,0,1-.13,2l4.13-.66c1.77,1.42,3.2,1.28,5.53,1.46.28,3,1.07,1.22,1.07,1.22l-.11-1.22c4.9,0,9.09-.3,13.95-.57,0,2,1,2.08,1-.06,7.95-.24,13.1,1.35,20.73,1.5a49.19,49.19,0,0,1,5.72.23c.22,1,3.29-1.06-3.45-1.17a70.09,70.09,0,0,1-10.39-.68c0-.3.13-2.06-1.12-1.53l0,.28h0l.12,1.13a58.71,58.71,0,0,0-11.73-.71.48.48,0,0,0-.8,0l-5.93.34,0-.13c4.27-.37,4.1,0,3.93-2l-.48-.28.42-.35Zm2,2.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M145.87,172.64Zm-2.33,6.76c.34.74-.5.67-1,.57l-.1.27c.13.07.42.32.56.32,0,.39.58,1-.9.62l-.07.18c1.2.59.71,1.17-.33.91l0,.08c.75.38,1,1.14-.11.94.4.18.86.68.18.88.49.65-.47.62-.86.49h0c.45.31-.32,2.57-1,2.39,0,.7-.38.87-.89.87-.41,1.24-.34,3.6-2.24,3.36a1.71,1.71,0,0,1-1.35-2.2c.26-.72.83-1.33,1.1-2.07-.59-.3-.32-.69-.12-1.23h0a.48.48,0,0,1-.28-.31l.23-.11-.21-.08a8,8,0,0,1,.66-1.79h0l.06-.09c-.31-.12-.7-.53-.23-.77-.07-.38.12-.55.49-.51-.45-.34-.21-.81.32-.73h0l.46.11v0l-.44-.24-.19-.13c0-1,0-.54,1-.54l0-.12-.6-.36c0-.62-.36-.78.94-.58l.05-.11c-.68-.68-1.17-1.29.38-1.06l.11-.3a1.64,1.64,0,0,1-.67-.49h0c-.47-.69.83-.52,1-.49l.13-.38a2,2,0,0,1-.71-.57c.1-.64.56-.49,1.08-.43l.16-.44c-.28-.17-.58-.3-.71-.61h0l0-.21c.33-.32.58-.26,1.07-.19l.18-.51c-.93-.6-.91-1.3.38-1l.21-.58c-1.1-.67-.79-1.14.38-1l.22-.62c-1.09-.65-.78-1.21.39-1.06l.25-.67c-1-.65-.89-1.31.39-1.09l.27-.74c-1-.58-.68-1.3.4-1.09L144,165c-1.07-.8-.77-1.13.41-1.13l.16-.42,3.77,1.84c-.14.11-.24.06-.42,0l-.29.8c.94.55.76,1.28-.4,1.09a3.14,3.14,0,0,1-.27.76c1,.59.67,1.27-.4,1.09l-.26.7c.43.3.64.37.66.92a1.06,1.06,0,0,1-1.05.16l-.24.65c.43.24,1.12.9.3,1.13l.15-.11-.55.07h.15l-.43,0-.22.59c1,.63.87,1.29-.38,1.05l-.19.53c.56.38,1.27,1.29,0,1.09l.17.06-.54-.12-.18.48.52.34h0c.6.64-.38.76-.88.66l-.15.43c1,.54.76,1.2-.36,1l-.11.31.26.12,0,0,.37.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M145.89,172.64Zm0-1c.34.3.81.82.09,1l.15-.11-.55.07h.15c-1.41-.12-2.78-.61-4.17-.85l-.13.33c-1.1-.67-.79-1.14.38-1h0c1.26.08,2.49.66,3.75.82l.13-.35.2.11Zm-.81,1.54c1.9,1.22,0,1.16-1.52.8l-2.59-.6-.12.34c-1.68-1.07-.05-1.14,1-.9a27.62,27.62,0,0,0,3.09.71v0h0l.09-.25h0l0-.07Zm-2.24,1.57a7.53,7.53,0,0,0,1.55.34l0-.05h0l.1-.28c.56.38,1.27,1.29,0,1.09l.17.06a31.42,31.42,0,0,0-4.27-1l-.08.23h0l0,.08c-.28-.17-.58-.3-.71-.61h0l0-.21c.66-.64,2.48.09,3.25.33Zm-.52,1.47,1.53.35.11-.3.51.34h0c1.48,1.58-4.36-.17-4.6-.22l-.1.29h0a2,2,0,0,1-.71-.57c.18-1.19,2.62.11,3.27.11ZM141,177.38l2.36.58.1-.27c1.36.74,1,1.28-.85.88-1.07-.25-2.13-.63-3.22-.81l-.1.27a1.71,1.71,0,0,1-.67-.49h0c-.68-1,2.37-.16,2.38-.16Zm-1.78,1,3.66.94L143,179l.26.12,0,0c1.19.6.23,1-.81.79l-3.49-.89-.13.35c-.68-.68-1.16-1.29.39-1.06h0Zm-.45,1.16a20.44,20.44,0,0,0,3.67,1l.06-.16,0-.08c.13.07.42.32.57.32,0,.51.9,1.14-2.48.21l-2.12-.56-.08.22h0l-.61-.36c0-.79-.51-.69.95-.58Zm-.38,1.06,3.66,1,0-.12h0l0-.07h0v0c1.65.82.57,1.16-.86.78-1-.27-2.08-.7-3.15-.87l-.07.2-.44-.24-.19-.13c0-1,0-.54,1-.54Zm-.54.88c1.28.35,2.55.82,3.84,1.1l.07-.19c.3,0,1.66,1.25-.1.94.4.18.86.68.18.88,1.2,1.56-4.81-.87-4.86-.77-.31-.12-.7-.53-.23-.77-.07-.38.12-.55.49-.51-.44-.34-.21-.81.33-.73h0l.28.06Zm10.11-15.12c2.19,1.92-4.41.17-4.47.16l-.13.39c-1.76-1-.25-1.23,1.17-1l3,.63.14-.4.3.17Zm-2.64,1.76,1.52.3.14-.37h0c1.55.89.22,1.21-.81,1s-2.22-.58-3.35-.7v0h0l-.12.35c-1.69-1.14.07-1.17,1.12-1l1.51.34Zm-.65,1.77a7.18,7.18,0,0,0,1.53.32l.13-.38c.43.3.64.37.67.92-.6.62-4-.48-4.81-.65l-.13.37h0c-1.69-1-.42-1.26,1.48-.84l1.13.26Zm-1.07-6h.84a11,11,0,0,1,3.94,1.41c-.46.34-3.49-.59-4.2-.7L144,165c-.41-.31-1-.65-.43-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M145.89,171.63a1.3,1.3,0,0,1,.46.63,2.42,2.42,0,0,0-.31-.33l-.2-.11-.13.35c-1.25-.16-2.49-.74-3.74-.81h0c-.68,0-1.07.09-1.07.34-.39-.44,0-.71.91-.64h0c1.26.08,2.49.66,3.75.82l.13-.35.2.11Zm-.8,1.54c.6.39.82.65.79.81a3.08,3.08,0,0,0-.64-.5l0,.07h0l-.08.24h0v0a29.79,29.79,0,0,1-3.08-.7c-.73-.17-1.71-.19-1.75.15-.6-.65.69-.66,1.59-.46a27.62,27.62,0,0,0,3.09.71v0h0l.08-.25h0l0-.07Zm-2.25,1.57a7.53,7.53,0,0,0,1.55.34l0-.05h0l.1-.28a1.79,1.79,0,0,1,.7.83,2.52,2.52,0,0,0-.55-.53l-.09.28h0l0,.06A6.75,6.75,0,0,1,143,175c-.77-.23-2.6-1-3.26-.32v.13a.76.76,0,0,1-.15-.23h0v-.21c.66-.64,2.48.09,3.25.33Zm-.52,1.47,1.53.35.11-.3.51.34h0a.69.69,0,0,1,.23.41.39.39,0,0,0-.08-.1h0l-.51-.34-.11.3-1.53-.36c-.62,0-2.93-1.21-3.24-.21a1.8,1.8,0,0,1-.18-.2c.18-1.19,2.62.11,3.27.11ZM141,177.38l2.36.58.1-.27c.57.3.83.58.81.76a2.71,2.71,0,0,0-.66-.46l-.1.28-2.36-.59s-2.51-.7-2.47-.07l-.06-.07h0c-.68-1,2.37-.16,2.38-.16Zm-1.78,1,3.66.94L143,179l.27.12,0,0c.43.22.58.41.55.56a2,2,0,0,0-.39-.25l0,0-.26-.12-.11.3-3.67-.94h0c-.81-.12-1.06,0-1,.22-.31-.42-.24-.69.87-.52h0Zm-.22,1.23a17.53,17.53,0,0,0,3.45.91l0-.16,0-.08c.13.07.42.32.57.32a1,1,0,0,0,.06.29c-.16-.07-.37-.25-.48-.31l0,.09,0,.16a21.17,21.17,0,0,1-3.68-1h0c-1.3-.1-1-.19-1,.35l-.13-.08c0-.79-.51-.69.94-.58h0c.05.07.12.13.18.2l0-.13Zm-.39,1.05,3.44.95,0-.12h0v0l.2.05c.5.27.68.48.64.63a3,3,0,0,0-.67-.43v0h0l0,.07h0l0,.12-3.65-1c-.94,0-1-.42-1,.34l-.16-.11c0-1,0-.58.86-.54l.3.18h0l0-.11Zm-.21,1c1.1.32,2.18.7,3.29.94v0a2.93,2.93,0,0,0,.48.07,1,1,0,0,1,.37.53,1.38,1.38,0,0,0-.63-.46l-.07.19c-1.3-.27-2.57-.74-3.85-1.1l-.28-.06h0c-.35-.05-.57.13-.56.36-.33-.33-.09-.73.41-.66h0v0l.19.12.43.25.08-.21.13,0Zm3.7,2a.4.4,0,0,1,.09.23,1.22,1.22,0,0,0-.37-.27l.28,0Zm-.1.85Zm-5.31-1.28c-.18-.17-.26-.41.06-.57-.06-.35.1-.52.42-.52a.49.49,0,0,0,.22.31c-.37,0-.56.14-.49.52-.15.07-.21.16-.21.26Zm11.27-16.88c.31.27.44.46.45.6a2.63,2.63,0,0,0-.29-.29l-.31-.18-.14.4-3-.62c-.94-.19-1.92-.16-2,.18-.6-.62.64-.72,1.81-.49l3,.63.14-.4.3.17Zm-2.64,1.76,1.52.3L147,168h0c.52.3.72.54.71.71a2.47,2.47,0,0,0-.56-.4h0l-.14.38-1.53-.3-1.51-.35c-.73-.15-1.81-.17-1.82.21-.62-.69.79-.69,1.67-.51l1.51.34Zm-.65,1.77a7.31,7.31,0,0,0,1.53.32l.13-.38c.36.25.56.34.64.67a2.7,2.7,0,0,0-.48-.36l-.14.37a7.89,7.89,0,0,1-1.52-.31l-1.14-.26c-1.25-.28-2.22-.27-2.27.06-.57-.61.56-.72,2.12-.37l1.13.26Zm-1.07-6h.84a11,11,0,0,1,3.94,1.41.58.58,0,0,1-.31.08,9.48,9.48,0,0,0-3.47-1.19h-.85a.53.53,0,0,0-.23.42c-.18-.21-.25-.44.08-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M149.19,166.37l-5.31,14.39a4.64,4.64,0,0,0,2.05,5.76c3.56,2,9.77.08,9.77.08L174,184.32l-6.21-10.75-18.56-7.2Zm-.39,16.74a1.6,1.6,0,1,0-.58,2.19,1.6,1.6,0,0,0,.58-2.19Zm11.2-.73a1.6,1.6,0,0,0-2.77,1.6,1.6,1.6,0,1,0,2.77-1.6Zm-7.85-12.47a1.6,1.6,0,1,0-.59,2.18,1.6,1.6,0,0,0,.59-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M145.39,180.28l9.78,3a1.32,1.32,0,0,0,1.66-.87l.35-1.12a1.33,1.33,0,0,0-.88-1.65l-9.78-3a1.31,1.31,0,0,0-1.65.87l-.35,1.12a1.33,1.33,0,0,0,.87,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M157.19,181.27a1.32,1.32,0,0,0-.89-1.6l-9.78-3a1.31,1.31,0,0,0-1.65.87l-.1.32a1.45,1.45,0,0,0,.76.58l10.28,3.19a1.41,1.41,0,0,0,1.38-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M145,177.21a1,1,0,0,0-.14.3l-.1.32a1.45,1.45,0,0,0,.76.58l10.28,3.19a1.43,1.43,0,0,0,1.15-.15,1.4,1.4,0,0,0-.94-1l-10.29-3.19a1.36,1.36,0,0,0-.72,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M177.67,188.62c-.58-.77-4,.13-4-.65h0l-.28-.28c-1.49,0-25.31,5.76-26.33,5.49-3.62-.94-5.81-1.52-9.82.16-3.61,1.51-9.06,3.76-11,7.55-.57,1.11-1.2,4-.81,5.34s2.15,2.81,3.35,3.56c5.93,3.69,7,1.37,8.91,1.95,4.68,1.43,8.46,1,12-2.52h0l.23-.23h0c1.61-1.59.93-1.28,3.4-1.78h0l4.74-1h0l3.67-.78h0l5.52-1.18h0c6-1.2,12.55-2.69,18.56-4,6.12-2.45-4.78-8.61-8.08-11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M113.09,196.35s4-8.63,10.08-11.46,9.48-2.17,12.65-1,21.08,9.35,24.43,10.6,7.84,4,12.79,3,10.53-1.91,10.53-1.91l5.93,5.14s-5.79,3.62-20.48,5.93-26.75,2.57-37,.46-13.7-2.77-19-10.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M135.71,184.79c-1.64-1-12-1.4-14.34,2.71s-3.09,6.95-2.61,9.17,1.88-.1,10.24-.19,22.31,7.24,31.39,7.19,13-3.18,13-3.18-32-14-37.72-15.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "112.94 198.91 115.98 202.31 117.54 200.92 114.49 197.51 112.94 198.91 112.94 198.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M124.91,190.73s15.6,5.66,20.17,7a64,64,0,0,0,12.19,2.83,65.75,65.75,0,0,0,6.61.65s-37.88-11.46-39-10.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M124.18,189.49s5.59-1.37,9.73-.36,26.34,8.27,29.24,9.65,4.35,2,3.41,2.47-1.59,1.09-11.17-.07-21.12-6.39-24-7.33a58.68,58.68,0,0,1-6.68-2.83s13.72,6.67,17.92,7.69,11.69,4.94,23.59,3.63a99.23,99.23,0,0,0,18.65-3.56l-1.45-1.23s-6.32,4.21-15.39,1.38-22.28-8.42-27.5-10.67-9.65-3.7-14.58-1.89-2.76,3-1.75,3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M122.8,191.4s11.84,5.83,18.82,8.33a52.15,52.15,0,0,0,13.23,2.84,124.5,124.5,0,0,1-12.75-3.71c-8.47-3-18.09-7.16-19.3-7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M124.91,191.21s15.6,5.66,20.17,7a63.3,63.3,0,0,0,12.19,2.83,65.75,65.75,0,0,0,6.61.65l-2.3-.69c-1-.09-2.41-.25-4.31-.49a63.3,63.3,0,0,1-12.19-2.83c-3.57-1.08-13.9-4.78-18.23-6.34a4.48,4.48,0,0,0-1.94-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M120,188.39a1.32,1.32,0,1,1,2.38,1,1.32,1.32,0,1,1-2.38-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M121.79,187.41a1.69,1.69,0,0,0-1.89,1.16,1.47,1.47,0,0,0,.72,2,1.45,1.45,0,0,0,1.36-.34,1.09,1.09,0,0,1-.69,0,1.3,1.3,0,0,1-.64-1.78,1.65,1.65,0,0,1,1.14-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M132,197.46a1.65,1.65,0,1,1-1.48-2A1.77,1.77,0,0,1,132,197.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M129,195.91a2,2,0,0,0-.45,1.59,1.77,1.77,0,0,0,1.86,1.65,1.61,1.61,0,0,0,1.29-1.17,1.52,1.52,0,0,1-.91.49,1.76,1.76,0,0,1-1.86-1.65,2,2,0,0,1,.07-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M160.3,187.47a9.91,9.91,0,1,1,9.91,9.91A9.91,9.91,0,0,1,160.3,187.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M162.09,187.47a8.12,8.12,0,0,0,15.06,4.2,8.11,8.11,0,0,1-14.31-5.23,8,8,0,0,1,1.17-4.2,8,8,0,0,0-1.92,5.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M164.08,187.47a6.13,6.13,0,1,1,6.13,6.13A6.13,6.13,0,0,1,164.08,187.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M164.08,187.47A6.13,6.13,0,0,0,175,191.29a6.13,6.13,0,0,1-10.22-4.56,6.06,6.06,0,0,1,1.34-3.82,6.11,6.11,0,0,0-2,4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M167.68,173.13s-2.38,2.51-.07,6.43a53.45,53.45,0,0,0,6.63,8.32l8.49,8.65a17.41,17.41,0,0,1,4.4,3.61c2.05,2.36-.94,4.41,3,5.19s23,5.82,41.52,5.82a169.2,169.2,0,0,0,32.25-2.67c3.93-.63,4.87-1.26,6.76-3.93s15.72-28.47,15.72-28.47L288,144.94l-24.38-32.71-12.43,6.13s-3.3.63,0,3.93,6.3,11.8,8.5,17.77,2.2,8.5,1.26,17.62-2,22.33-2,22.33l-6.6,7.87s-.63,3.46-6.92,3.46-20.76-.16-20.76-.16l-11.64-21.07s-1.58-1.89,1.25-5.2a72.29,72.29,0,0,1,5-5.34l-1.1-1.58,5-6.44-1.73-1.42-.31-3.15-48.63-1.31-4.8,27.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M293.88,203.59l1.6,1a1.23,1.23,0,0,0,2,1.33l.68.46c.74.49,2.14.41,3.41-.87s1.07-2.75,1.19-4.43,3.58-6.08,3.58-6.08-1.23-1.15-4.32-.78a44.41,44.41,0,0,0-7.14,1.73l-1,7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M305,192.28A12.89,12.89,0,1,0,322.6,197,12.89,12.89,0,0,0,305,192.28Zm2.29,4a8.3,8.3,0,1,0,11.35,3,8.3,8.3,0,0,0-11.35-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M311.24,190.44a12.73,12.73,0,0,0-12.76,12.93,13.14,13.14,0,0,0,13.1,12.94,12.73,12.73,0,0,0,12.76-12.94,13.14,13.14,0,0,0-13.1-12.93Zm-4.11,5.81a8.3,8.3,0,1,0,11.35,3,8.29,8.29,0,0,0-11.35-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M311.14,190.63a12.65,12.65,0,0,0-9.88,4.71,12.65,12.65,0,0,1,9.48-4.23,13.07,13.07,0,0,1,13,12.86,12.68,12.68,0,0,1-2.81,8.16,12.67,12.67,0,0,0,3.21-8.63,13.07,13.07,0,0,0-13-12.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M309.63,191.55a.22.22,0,0,0-.22.22.22.22,0,0,0,.23.22.21.21,0,0,0,.21-.22.22.22,0,0,0-.22-.22Zm1.48,1.66a.21.21,0,0,0-.21.22.22.22,0,1,0,.44,0,.24.24,0,0,0-.23-.22Zm.25,1a.22.22,0,0,0-.22.22.22.22,0,0,0,.22.22.22.22,0,0,0,.22-.22.22.22,0,0,0-.22-.22Zm-.83-1.92a.22.22,0,0,0-.22.22.22.22,0,0,0,.22.23.22.22,0,0,0,.22-.23.22.22,0,0,0-.22-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M309.63,191.45a.23.23,0,0,0-.22.23.22.22,0,0,0,.23.22.21.21,0,0,0,.21-.22.23.23,0,0,0-.22-.23Zm1.48,1.67a.22.22,0,0,0-.22.22.24.24,0,0,0,.23.22.21.21,0,0,0,.21-.22.22.22,0,0,0-.22-.22Zm.25,1a.21.21,0,0,0-.22.22.22.22,0,1,0,.44,0,.22.22,0,0,0-.22-.22Zm-.83-1.92a.22.22,0,0,0-.22.22.22.22,0,0,0,.22.22.22.22,0,0,0,.22-.22.22.22,0,0,0-.22-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M312.73,191.52a.21.21,0,0,0-.26.16.22.22,0,0,0,.43.12.25.25,0,0,0-.17-.28Zm1,2a.22.22,0,0,0-.27.16.23.23,0,0,0,.16.27.22.22,0,0,0,.11-.43Zm0,1a.22.22,0,0,0-.27.15.24.24,0,0,0,.16.28.22.22,0,0,0,.27-.16.23.23,0,0,0-.16-.27Zm-.32-2.06a.22.22,0,1,0-.11.42.21.21,0,0,0,.27-.15.22.22,0,0,0-.16-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M312.76,191.43a.22.22,0,1,0,.16.28.25.25,0,0,0-.16-.28Zm1,2a.22.22,0,0,0-.27.16.23.23,0,0,0,.16.27.22.22,0,0,0,.11-.43Zm0,1a.22.22,0,0,0-.27.15.24.24,0,0,0,.16.28.22.22,0,0,0,.11-.43Zm-.32-2.06a.22.22,0,0,0-.26.15.22.22,0,0,0,.16.27.2.2,0,0,0,.26-.15.21.21,0,0,0-.16-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M315.75,192.31a.22.22,0,0,0-.3.08.23.23,0,1,0,.39.23.25.25,0,0,0-.09-.31Zm.47,2.18a.22.22,0,0,0-.3.08.24.24,0,0,0,.09.31.23.23,0,0,0,.3-.08.23.23,0,0,0-.09-.31Zm-.26,1a.21.21,0,0,0-.3.08.22.22,0,0,0,.08.3.21.21,0,0,0,.3-.08.23.23,0,0,0-.08-.3Zm.22-2.07a.22.22,0,0,0-.3.08.23.23,0,0,0,.09.31.21.21,0,0,0,.29-.08.23.23,0,0,0-.08-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M315.79,192.23a.21.21,0,0,0-.29.08.22.22,0,0,0,.08.31.22.22,0,0,0,.3-.08.23.23,0,0,0-.09-.31Zm.48,2.18a.22.22,0,0,0-.3.08.23.23,0,0,0,.09.31.21.21,0,0,0,.29-.08.24.24,0,0,0-.08-.31Zm-.27,1a.22.22,0,1,0-.21.38.21.21,0,0,0,.3-.08.22.22,0,0,0-.09-.3Zm.22-2.07a.22.22,0,0,0-.3.08.24.24,0,0,0,.09.31.23.23,0,0,0,.3-.08.23.23,0,0,0-.09-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M318.47,193.87a.22.22,0,0,0-.31,0,.23.23,0,0,0,0,.32.22.22,0,0,0,.32,0,.22.22,0,0,0,0-.31Zm-.1,2.22a.22.22,0,0,0-.31,0,.23.23,0,0,0,0,.32.21.21,0,0,0,.31,0,.22.22,0,0,0,0-.31Zm-.5.85a.21.21,0,0,0-.31,0,.22.22,0,0,0,0,.31.21.21,0,0,0,.31,0,.22.22,0,0,0,0-.31Zm.74-1.93a.21.21,0,0,0-.31,0,.22.22,0,0,0,0,.31.21.21,0,0,0,.31,0,.22.22,0,0,0,0-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M318.53,193.8a.21.21,0,0,0-.31,0,.23.23,0,0,0,.32.32.22.22,0,0,0,0-.32Zm-.09,2.22a.21.21,0,0,0-.31,0,.22.22,0,0,0,0,.31.23.23,0,0,0,.32,0,.24.24,0,0,0,0-.32Zm-.5.85a.24.24,0,0,0-.32,0,.23.23,0,0,0,0,.32.22.22,0,0,0,.31,0,.24.24,0,0,0,0-.32Zm.74-1.93a.21.21,0,0,0-.31,0,.23.23,0,0,0,0,.32.23.23,0,0,0,.31,0,.23.23,0,0,0,0-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M320.71,196.07a.23.23,0,0,0-.3-.08.24.24,0,0,0-.08.31.24.24,0,0,0,.31.08.23.23,0,0,0,.07-.31Zm-.66,2.12a.22.22,0,0,0-.3-.09.24.24,0,0,0-.08.31.24.24,0,0,0,.31.08.22.22,0,0,0,.07-.3Zm-.7.68a.24.24,0,0,0-.31-.08.23.23,0,0,0-.07.31.22.22,0,1,0,.38-.23Zm1.21-1.66a.22.22,0,0,0-.3-.08.21.21,0,0,0-.08.3.22.22,0,0,0,.3.09.23.23,0,0,0,.08-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M320.79,196a.22.22,0,0,0-.3-.09.23.23,0,0,0,.23.39.22.22,0,0,0,.07-.3Zm-.66,2.11a.22.22,0,0,0-.3-.08.22.22,0,0,0,.22.39.23.23,0,0,0,.08-.31Zm-.71.69a.21.21,0,0,0-.3-.08.22.22,0,0,0-.07.3.22.22,0,0,0,.3.08.2.2,0,0,0,.07-.3Zm1.22-1.67a.22.22,0,1,0-.38.23.22.22,0,1,0,.38-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M322.32,198.79a.23.23,0,0,0-.27-.16.21.21,0,0,0-.15.27.22.22,0,0,0,.27.16.21.21,0,0,0,.15-.27Zm-1.18,1.86a.22.22,0,0,0-.27-.16.21.21,0,0,0-.15.27.22.22,0,0,0,.27.16.21.21,0,0,0,.15-.27Zm-.86.47A.21.21,0,0,0,320,201a.22.22,0,0,0-.15.27.22.22,0,1,0,.42-.12Zm1.6-1.28a.22.22,0,0,0-.27-.16.23.23,0,0,0-.15.28.23.23,0,0,0,.27.16.23.23,0,0,0,.15-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M322.41,198.76a.23.23,0,0,0-.27-.16.23.23,0,0,0,.12.44.24.24,0,0,0,.15-.28Zm-1.18,1.86a.22.22,0,1,0-.42.12.22.22,0,0,0,.27.16.24.24,0,0,0,.15-.28Zm-.86.48a.22.22,0,0,0-.27-.16.21.21,0,0,0-.15.27.21.21,0,0,0,.27.16.22.22,0,0,0,.15-.27Zm1.6-1.28a.23.23,0,0,0-.27-.16.21.21,0,0,0-.15.27.22.22,0,1,0,.42-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M323.19,201.82a.23.23,0,0,0-.23-.22.22.22,0,1,0,.23.22Zm-1.62,1.48a.22.22,0,1,0-.44,0,.23.23,0,0,0,.22.23.22.22,0,0,0,.22-.23Zm-.95.24a.24.24,0,0,0-.23-.23.22.22,0,0,0-.21.23.22.22,0,0,0,.44,0Zm1.87-.82a.22.22,0,0,0-.22-.22.21.21,0,0,0-.21.22.23.23,0,0,0,.22.23.22.22,0,0,0,.21-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M323.28,201.82a.23.23,0,0,0-.22-.22.22.22,0,1,0,.22.22Zm-1.62,1.48a.22.22,0,0,0-.44,0,.23.23,0,0,0,.23.23.22.22,0,0,0,.21-.23Zm-1,.24a.23.23,0,0,0-.23-.23.22.22,0,0,0-.21.23.22.22,0,1,0,.44,0Zm1.87-.82a.22.22,0,0,0-.22-.22.21.21,0,0,0-.21.22.23.23,0,0,0,.22.23.22.22,0,0,0,.21-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M323.25,205a.23.23,0,0,0-.15-.28.22.22,0,0,0-.27.16.24.24,0,0,0,.16.28.21.21,0,0,0,.26-.16Zm-1.94,1a.23.23,0,0,0-.16-.28.22.22,0,0,0-.27.16.23.23,0,0,0,.16.28.22.22,0,0,0,.27-.16Zm-1,0a.22.22,0,0,0-.16-.27.21.21,0,0,0-.26.16.22.22,0,1,0,.42.11Zm2-.29a.22.22,0,0,0-.16-.27.21.21,0,0,0-.26.16.22.22,0,1,0,.42.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M323.34,205a.22.22,0,0,0-.16-.27.21.21,0,0,0-.26.16.22.22,0,1,0,.42.11Zm-1.95,1a.22.22,0,1,0-.26.16.21.21,0,0,0,.26-.16Zm-1,0a.23.23,0,0,0-.16-.28.21.21,0,0,0-.26.16.24.24,0,0,0,.15.28.22.22,0,0,0,.27-.16Zm2-.29a.23.23,0,0,0-.16-.28.21.21,0,0,0-.26.16.24.24,0,0,0,.15.28.22.22,0,0,0,.27-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M322.51,208a.22.22,0,0,0-.08-.3.21.21,0,0,0-.3.08.23.23,0,0,0,.09.31.21.21,0,0,0,.29-.09Zm-2.14.46a.24.24,0,0,0-.08-.31.22.22,0,0,0-.3.08.24.24,0,0,0,.08.31.22.22,0,0,0,.3-.08Zm-.95-.29a.22.22,0,0,0-.08-.3.21.21,0,0,0-.3.08.24.24,0,0,0,.08.31.22.22,0,0,0,.3-.09Zm2,.26a.22.22,0,1,0-.38-.23.23.23,0,0,0,.09.31.21.21,0,0,0,.29-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M322.59,208.06a.24.24,0,0,0-.08-.31.22.22,0,0,0-.3.09.23.23,0,0,0,.08.3.21.21,0,0,0,.3-.08Zm-2.14.45a.22.22,0,0,0-.08-.3.21.21,0,0,0-.3.08.22.22,0,0,0,.08.3.21.21,0,0,0,.3-.08Zm-.95-.28a.24.24,0,0,0-.08-.31.22.22,0,0,0-.3.09.22.22,0,0,0,.08.3.21.21,0,0,0,.3-.08Zm2,.25a.21.21,0,0,0-.08-.3.22.22,0,1,0-.21.38.2.2,0,0,0,.29-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M321,210.75a.23.23,0,0,0,0-.31.22.22,0,1,0,0,.31Zm-2.19-.13a.22.22,0,0,0,0-.31.21.21,0,0,0-.31,0,.22.22,0,0,0,0,.31.21.21,0,0,0,.31,0Zm-.85-.52a.23.23,0,0,0,0-.31.22.22,0,0,0-.32,0,.22.22,0,0,0,0,.31.21.21,0,0,0,.31,0Zm1.91.78a.22.22,0,1,0-.31-.31.23.23,0,0,0,0,.31.21.21,0,0,0,.31,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M321.08,210.82a.22.22,0,0,0,0-.32.21.21,0,0,0-.31,0,.24.24,0,0,0,0,.32.22.22,0,0,0,.31,0Zm-2.19-.13a.22.22,0,0,0,0-.32.23.23,0,0,0-.31,0,.24.24,0,0,0,0,.32.21.21,0,0,0,.31,0Zm-.84-.52a.23.23,0,0,0,0-.32.23.23,0,0,0-.31,0,.23.23,0,0,0,0,.32.21.21,0,0,0,.31,0ZM320,211a.22.22,0,0,0,0-.32.23.23,0,0,0-.31,0,.22.22,0,0,0,0,.32.22.22,0,0,0,.31,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M318.87,213a.21.21,0,0,0,.08-.3.22.22,0,1,0-.08.3Zm-2.09-.7a.22.22,0,0,0,.08-.3.23.23,0,0,0-.31-.08.21.21,0,0,0-.07.3.21.21,0,0,0,.3.08Zm-.69-.72a.23.23,0,0,0,.08-.3.22.22,0,0,0-.38.22.21.21,0,0,0,.3.08Zm1.66,1.25a.22.22,0,0,0,.08-.3.22.22,0,1,0-.38.22.21.21,0,0,0,.3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M318.92,213.07a.22.22,0,1,0-.3-.08.21.21,0,0,0,.3.08Zm-2.1-.7a.21.21,0,0,0,.08-.3.22.22,0,0,0-.3-.08.24.24,0,0,0-.08.31.21.21,0,0,0,.3.07Zm-.68-.72a.23.23,0,0,0,.08-.3.23.23,0,0,0-.31-.08.22.22,0,0,0-.07.3.21.21,0,0,0,.3.08Zm1.65,1.25a.21.21,0,0,0,.08-.3.21.21,0,0,0-.3-.08.23.23,0,0,0-.08.3.22.22,0,0,0,.3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M316.22,214.59a.23.23,0,0,0,.15-.28.22.22,0,0,0-.27-.15.21.21,0,0,0-.15.27.22.22,0,0,0,.27.16Zm-1.85-1.22a.23.23,0,0,0,.15-.27.22.22,0,0,0-.43.11.24.24,0,0,0,.28.16Zm-.49-.88a.23.23,0,0,0,.16-.27.24.24,0,0,0-.28-.16.23.23,0,0,0-.15.27.23.23,0,0,0,.27.16Zm1.29,1.64a.21.21,0,0,0,.15-.27.22.22,0,1,0-.15.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M316.24,214.68a.24.24,0,0,0,.16-.28.24.24,0,0,0-.28-.15.22.22,0,0,0-.15.27.23.23,0,0,0,.27.16Zm-1.85-1.22a.22.22,0,1,0-.27-.16.22.22,0,0,0,.27.16Zm-.48-.88a.23.23,0,0,0,.15-.27.22.22,0,0,0-.27-.16.21.21,0,0,0-.15.27.22.22,0,0,0,.27.16Zm1.29,1.64a.22.22,0,0,0,.15-.27.22.22,0,0,0-.43.11.24.24,0,0,0,.28.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M313.24,215.42a.22.22,0,0,0,.22-.22.24.24,0,0,0-.23-.22.22.22,0,1,0,0,.44Zm-1.49-1.66a.21.21,0,0,0,.22-.22.22.22,0,0,0-.44,0,.22.22,0,0,0,.22.22Zm-.24-1a.22.22,0,0,0,.22-.22.22.22,0,0,0-.23-.22.22.22,0,0,0-.22.22.24.24,0,0,0,.23.22Zm.83,1.92a.22.22,0,0,0,.22-.22.24.24,0,0,0-.23-.22.21.21,0,0,0-.21.22.22.22,0,0,0,.22.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M313.24,215.52a.22.22,0,0,0,.22-.22.23.23,0,1,0-.22.22Zm-1.49-1.66a.21.21,0,0,0,.22-.22.22.22,0,1,0-.22.22Zm-.24-1a.23.23,0,1,0,0-.45.22.22,0,0,0-.22.22.24.24,0,0,0,.23.23Zm.83,1.91a.22.22,0,1,0,0-.44.21.21,0,0,0-.22.22.22.22,0,0,0,.22.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M310.13,215.45a.22.22,0,0,0,.27-.16.23.23,0,0,0-.16-.27.22.22,0,0,0-.27.16.23.23,0,0,0,.16.27Zm-1-2a.21.21,0,0,0,.27-.15.22.22,0,0,0-.16-.27.21.21,0,0,0-.27.15.22.22,0,0,0,.16.27Zm0-1a.21.21,0,0,0,.27-.15.22.22,0,0,0-.16-.27.21.21,0,0,0-.27.15.22.22,0,0,0,.16.27Zm.31,2.07a.22.22,0,1,0-.16-.27.25.25,0,0,0,.16.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M310.11,215.54a.22.22,0,1,0-.16-.27.22.22,0,0,0,.16.27Zm-1-2a.21.21,0,0,0,.27-.15.23.23,0,0,0-.17-.27.2.2,0,0,0-.26.15.22.22,0,0,0,.16.27Zm0-1a.21.21,0,0,0,.27-.15.23.23,0,0,0-.16-.27.21.21,0,0,0-.27.15.22.22,0,0,0,.16.27Zm.31,2.07a.22.22,0,1,0-.16-.28.24.24,0,0,0,.16.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M307.12,214.66a.23.23,0,0,0,.3-.08.22.22,0,0,0-.09-.3.21.21,0,0,0-.3.08.22.22,0,0,0,.09.3Zm-.48-2.18a.21.21,0,0,0,.3-.08.23.23,0,0,0-.08-.3.21.21,0,0,0-.3.08.23.23,0,0,0,.08.3Zm.27-1a.21.21,0,0,0,.3-.08.22.22,0,0,0-.09-.3.21.21,0,0,0-.3.08.22.22,0,0,0,.09.3Zm-.22,2.07a.22.22,0,0,0,.3-.08.23.23,0,0,0-.09-.3.21.21,0,0,0-.3.08.22.22,0,0,0,.09.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M307.07,214.74a.21.21,0,0,0,.3-.08.22.22,0,0,0-.08-.3.21.21,0,0,0-.3.07.24.24,0,0,0,.08.31Zm-.47-2.18a.22.22,0,0,0,.3-.08.22.22,0,0,0-.09-.3.21.21,0,0,0-.3.08.22.22,0,0,0,.09.3Zm.26-1a.21.21,0,0,0,.3-.08.23.23,0,0,0-.08-.3.21.21,0,0,0-.3.08.22.22,0,0,0,.08.3Zm-.22,2.07a.21.21,0,0,0,.3-.08.22.22,0,0,0-.08-.3.21.21,0,0,0-.3.08.23.23,0,0,0,.08.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M304.4,213.11a.22.22,0,0,0,.31,0,.23.23,0,0,0,0-.32.23.23,0,0,0-.31,0,.23.23,0,0,0,0,.32Zm.09-2.22a.23.23,0,0,0,.31,0,.23.23,0,0,0,0-.32.22.22,0,0,0-.31,0,.23.23,0,0,0,0,.32ZM305,210a.22.22,0,0,0,.31,0,.23.23,0,0,0,0-.32.21.21,0,0,0-.31,0,.22.22,0,0,0,0,.31Zm-.75,1.94a.23.23,0,0,0,.31,0,.23.23,0,0,0,0-.32.22.22,0,0,0-.31,0,.23.23,0,0,0,0,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M304.33,213.17a.22.22,0,1,0,0-.31.21.21,0,0,0,0,.31Zm.1-2.22a.21.21,0,0,0,.31,0,.22.22,0,0,0,0-.31.21.21,0,0,0-.31,0,.22.22,0,0,0,0,.31Zm.5-.85a.21.21,0,0,0,.31,0,.22.22,0,0,0-.31-.32.22.22,0,0,0,0,.32Zm-.74,1.93a.21.21,0,0,0,.31,0,.23.23,0,0,0-.32-.32.23.23,0,0,0,0,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M302.16,210.9a.21.21,0,0,0,.3.08.22.22,0,0,0,.07-.3.22.22,0,0,0-.3-.09.22.22,0,0,0-.07.31Zm.66-2.11a.22.22,0,1,0,.37-.22.22.22,0,0,0-.3-.09.22.22,0,0,0-.07.31Zm.7-.69a.22.22,0,0,0,.3.08.21.21,0,0,0,.07-.3.22.22,0,0,0-.3-.09.23.23,0,0,0-.07.31Zm-1.21,1.66a.21.21,0,0,0,.3.08.22.22,0,0,0,.07-.3.21.21,0,0,0-.3-.08.22.22,0,0,0-.07.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M302.08,211a.23.23,0,0,0,.3.08.21.21,0,0,0,.07-.3.22.22,0,0,0-.3-.09.23.23,0,0,0-.07.31Zm.66-2.12a.22.22,0,0,0,.3.09.23.23,0,0,0,.07-.31.22.22,0,1,0-.37.22Zm.7-.68a.22.22,0,1,0,.38-.23.22.22,0,1,0-.38.23Zm-1.21,1.66a.22.22,0,0,0,.3.08.23.23,0,0,0,.08-.3.23.23,0,0,0-.31-.09.24.24,0,0,0-.07.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M300.55,208.19a.23.23,0,0,0,.27.16.24.24,0,0,0,.15-.28.23.23,0,0,0-.27-.16.22.22,0,0,0-.15.28Zm1.18-1.86a.22.22,0,0,0,.27.16.23.23,0,0,0,.15-.28.23.23,0,0,0-.27-.16.22.22,0,0,0-.15.28Zm.85-.48a.23.23,0,0,0,.27.16.23.23,0,0,0,.16-.27.23.23,0,0,0-.27-.17.24.24,0,0,0-.16.28Zm-1.6,1.28a.23.23,0,0,0,.27.16.21.21,0,0,0,.15-.27.22.22,0,1,0-.42.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M300.46,208.21a.22.22,0,0,0,.27.16.23.23,0,0,0,.15-.28.23.23,0,0,0-.27-.15.21.21,0,0,0-.15.27Zm1.18-1.86a.22.22,0,1,0,.42-.11.23.23,0,0,0-.27-.16.21.21,0,0,0-.15.27Zm.86-.48a.22.22,0,1,0,.42-.11.23.23,0,0,0-.27-.16.21.21,0,0,0-.15.27Zm-1.6,1.29a.21.21,0,0,0,.27.15.22.22,0,0,0,.15-.27.23.23,0,0,0-.27-.16.22.22,0,0,0-.15.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M299.68,205.15a.22.22,0,1,0,.44,0,.22.22,0,0,0-.44,0Zm1.62-1.48a.22.22,0,0,0,.22.23.22.22,0,0,0,.21-.23.22.22,0,0,0-.22-.22.21.21,0,0,0-.21.22Zm.95-.23a.22.22,0,0,0,.22.22.22.22,0,0,0,.22-.22.22.22,0,1,0-.44,0Zm-1.88.81a.22.22,0,1,0,.44,0,.22.22,0,0,0-.44,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M299.59,205.15a.22.22,0,1,0,.44,0,.24.24,0,0,0-.23-.22.21.21,0,0,0-.21.22Zm1.62-1.48a.22.22,0,0,0,.22.23.22.22,0,0,0,.21-.23.22.22,0,0,0-.22-.22.21.21,0,0,0-.21.22Zm1-.23a.22.22,0,1,0,.22-.22.22.22,0,0,0-.22.22Zm-1.88.81a.22.22,0,1,0,.44,0,.22.22,0,0,0-.44,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M299.61,202a.23.23,0,0,0,.16.27.22.22,0,1,0-.16-.27Zm1.95-1a.22.22,0,0,0,.16.27.21.21,0,0,0,.26-.16.22.22,0,0,0-.16-.27.21.21,0,0,0-.26.16Zm1,0a.22.22,0,0,0,.15.27.21.21,0,0,0,.27-.15.23.23,0,0,0-.16-.28.21.21,0,0,0-.26.16Zm-2,.29a.22.22,0,0,0,.15.27.21.21,0,0,0,.27-.15.24.24,0,0,0-.16-.28.21.21,0,0,0-.26.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M299.52,202a.24.24,0,0,0,.16.27.21.21,0,0,0,.27-.15.24.24,0,0,0-.16-.28.22.22,0,0,0-.27.16Zm2-1a.24.24,0,0,0,.16.28.23.23,0,0,0,.27-.16.25.25,0,0,0-.16-.28.22.22,0,0,0-.27.16Zm1,0a.22.22,0,1,0,.26-.16.21.21,0,0,0-.26.16Zm-2,.29a.22.22,0,1,0,.26-.16.21.21,0,0,0-.26.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M300.35,199a.23.23,0,0,0,.09.3.2.2,0,0,0,.29-.08.21.21,0,0,0-.08-.3.22.22,0,0,0-.3.08Zm2.15-.45a.21.21,0,0,0,.08.3.22.22,0,1,0,.21-.38.2.2,0,0,0-.29.08Zm.94.28a.23.23,0,0,0,.09.31.22.22,0,0,0,.21-.39.22.22,0,0,0-.3.08Zm-2-.25a.22.22,0,0,0,.08.3.22.22,0,0,0,.22-.38.21.21,0,0,0-.3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M300.27,198.91a.23.23,0,0,0,.09.31.21.21,0,0,0,.29-.09.22.22,0,0,0-.08-.3.23.23,0,0,0-.3.08Zm2.15-.45a.23.23,0,0,0,.08.31.22.22,0,1,0,.21-.39.21.21,0,0,0-.29.08Zm.94.29a.22.22,0,0,0,.09.3.22.22,0,0,0,.3-.09.23.23,0,0,0-.09-.3.22.22,0,0,0-.3.09Zm-2-.26a.24.24,0,0,0,.08.31.22.22,0,0,0,.3-.09.22.22,0,0,0-.38-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M301.85,196.22a.22.22,0,0,0,0,.32.23.23,0,0,0,.31,0,.22.22,0,0,0,0-.32.23.23,0,0,0-.31,0Zm2.19.13a.23.23,0,0,0,0,.32.22.22,0,0,0,.31,0,.22.22,0,1,0-.31-.31Zm.85.52a.22.22,0,0,0,0,.32.22.22,0,0,0,.31-.32.21.21,0,0,0-.31,0Zm-1.92-.78a.24.24,0,0,0,0,.32.22.22,0,0,0,.31,0,.22.22,0,1,0-.31-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M301.78,196.16a.23.23,0,0,0,0,.31.22.22,0,1,0,0-.31Zm2.19.12a.23.23,0,0,0,0,.32.21.21,0,0,0,.31,0,.23.23,0,0,0,0-.32.23.23,0,0,0-.31,0Zm.85.53a.23.23,0,0,0,0,.31.21.21,0,0,0,.31,0,.22.22,0,0,0,0-.32.22.22,0,0,0-.31,0Zm-1.91-.78a.22.22,0,0,0,.31.31.23.23,0,0,0,0-.31.21.21,0,0,0-.31,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M304,194a.22.22,0,0,0-.08.3.21.21,0,0,0,.3.08.22.22,0,0,0,.08-.3.23.23,0,0,0-.3-.08Zm2.09.7a.22.22,0,0,0-.08.3.21.21,0,0,0,.3.08.23.23,0,0,0,.08-.3.22.22,0,0,0-.3-.08Zm.69.72a.23.23,0,0,0-.08.31.21.21,0,0,0,.3.07.22.22,0,0,0,.08-.3.22.22,0,0,0-.3-.08Zm-1.66-1.25a.22.22,0,1,0,.3.08.22.22,0,0,0-.3-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M304,193.9a.22.22,0,0,0,.22.38.21.21,0,0,0,.08-.3.22.22,0,0,0-.3-.08Zm2.09.7a.23.23,0,0,0-.08.3.22.22,0,0,0,.38-.22.21.21,0,0,0-.3-.08Zm.69.72a.22.22,0,0,0,.22.39.23.23,0,0,0,.08-.31.23.23,0,0,0-.3-.08Zm-1.66-1.25a.23.23,0,0,0-.08.3.22.22,0,0,0,.3.08.21.21,0,0,0,.08-.3.21.21,0,0,0-.3-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M306.65,192.39a.22.22,0,1,0,.12.42.21.21,0,0,0,.15-.27.21.21,0,0,0-.27-.15Zm1.85,1.22a.21.21,0,0,0-.15.27.21.21,0,0,0,.27.15.21.21,0,0,0,.15-.27.21.21,0,0,0-.27-.15Zm.48.87a.23.23,0,0,0-.15.28.22.22,0,0,0,.43-.12.24.24,0,0,0-.28-.16Zm-1.28-1.64a.24.24,0,0,0-.16.28.23.23,0,0,0,.27.15A.22.22,0,0,0,308,193a.23.23,0,0,0-.27-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M306.62,192.3a.22.22,0,0,0-.15.27.21.21,0,0,0,.27.15.22.22,0,1,0-.12-.42Zm1.86,1.22a.22.22,0,0,0-.16.27.21.21,0,0,0,.27.15.22.22,0,0,0,.16-.27.22.22,0,0,0-.27-.15Zm.48.87a.24.24,0,0,0-.16.28.24.24,0,0,0,.28.15.22.22,0,0,0-.12-.43Zm-1.29-1.64a.22.22,0,0,0,.12.43.21.21,0,0,0,.15-.27.22.22,0,0,0-.27-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M315.55,186l-2.93-.06a13.38,13.38,0,0,1,1.42,9.14,7.57,7.57,0,0,1-.68,2.05,1.83,1.83,0,0,1-1,1,.87.87,0,0,1-.75-.14h0a24,24,0,0,0-7.23-3.43,20.7,20.7,0,0,0-8.22-.53l-1,2.77a13.38,13.38,0,0,1,9.13,1.47,7.54,7.54,0,0,1,1.74,1.28,1.92,1.92,0,0,1,.66,1.26.86.86,0,0,1-.37.67,23.9,23.9,0,0,0-5.5,5.82,20.53,20.53,0,0,0-3,7.64l2.34,1.77a13.31,13.31,0,0,1,4.22-8.22,7.55,7.55,0,0,1,1.75-1.26,1.86,1.86,0,0,1,1.4-.24.85.85,0,0,1,.53.56,24,24,0,0,0,3.83,7,20.7,20.7,0,0,0,6.33,5.25l2.41-1.67a13.34,13.34,0,0,1-6.52-6.56,8,8,0,0,1-.66-2.06,1.93,1.93,0,0,1,.21-1.4h0a.86.86,0,0,1,.7-.33,24.13,24.13,0,0,0,7.86-1.47,20.56,20.56,0,0,0,6.95-4.41l-.84-2.8a13.29,13.29,0,0,1-8.26,4.17,7.36,7.36,0,0,1-2.16,0,1.91,1.91,0,0,1-1.27-.63h0a.86.86,0,0,1-.09-.76h0a24,24,0,0,0,1-7.94,20.67,20.67,0,0,0-2-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M314.13,186h-.73a11.1,11.1,0,0,1,1.47,6c-.28,3.74.61,5.8-2,6.86s-3.41,2.12-.79,3.63c2.33,1.33,4.52,1.31,4.48,0a.92.92,0,0,1,0-.29c0-.09-.05-.18-.08-.28-.73-1.84-.67-1.95-.62-4.57.05-2.2.06-9-1.68-11.36ZM328.91,201l-.39-1.3a11.76,11.76,0,0,1-3.22,2.17c-4.12,1.94-6.64,3.38-2.2,2.06,3.13-.93,4.53-1.65,5.81-2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M313.25,185.68h.66a2.75,2.75,0,0,1,.22.26h-.73a2,2,0,0,0-.15-.26Zm15.48,13.84.39,1.28-.21.22-.39-1.29a2.08,2.08,0,0,1,.21-.21Zm-12.18,2.93a1,1,0,0,0,0-.29.92.92,0,0,0,0,.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M340.67,203.44a29.18,29.18,0,1,0-29.18,29.17,29.18,29.18,0,0,0,29.18-29.17Zm-12.65,0A16.53,16.53,0,1,0,311.49,220,16.53,16.53,0,0,0,328,203.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M330.31,184.84l3.07,2.28c-1.35.2-.76,0-2.25.94l0-.18-1.95-2.24,1.08-.82v0Zm7.36,14.87,1.11,3.66c-1.21-.64-.6-.46-2.37-.58l.15-.12-.24-3,1.35,0v0Zm-10.32-17.46,3.37,1.81c-1.31.39-.75.1-2.08,1.26v-.19l-2.25-1.93.93-1Zm-37.1,5.27,1.8-3.37c.4,1.31.1.75,1.26,2.09l-.18,0-1.93,2.26-1-.94,0,0Zm42.37,31.84-1.8,3.37c-.4-1.31-.1-.75-1.27-2.09l.19,0,1.93-2.26,1,.94v0Zm-4.49,8.06,3.14-2.69c-1.79,2.08-1.11,1.34-3.82,3.28l.68-.59Zm4.75-5.5a3.52,3.52,0,0,1-.59,1.26h0c-.85,1.45-2.06,2.23-3.57,3.56a56,56,0,0,0,4.15-4.82Zm.06-2.08c.62,1.64,0,1.65-2.49,4.84a33.2,33.2,0,0,1,2.49-4.84Zm-38.2-40.39-3.15,2.7c1.8-2.08,1.12-1.35,3.83-3.28l-.68.58ZM290,185a3.59,3.59,0,0,1,.58-1.26h0c.84-1.46,2.06-2.24,3.57-3.56A54.57,54.57,0,0,0,290,185Zm-.07,2.08c-.61-1.64.05-1.65,2.5-4.84a33.29,33.29,0,0,1-2.5,4.84Zm5.6,37.59-3.37-1.81c1.3-.39.74-.1,2.08-1.26v.19l2.25,1.93-.94,1Zm-8.07-4.5,2.69,3.15c-2.07-1.79-1.34-1.11-3.28-3.83l.59.68Zm5.5,4.75a3.63,3.63,0,0,1-1.25-.58h0c-1.45-.84-2.23-2.06-3.56-3.57a57.6,57.6,0,0,0,4.82,4.15ZM295,225c-1.65.61-1.66,0-4.84-2.5A33.29,33.29,0,0,1,295,225Zm40.38-38.21-2.7-3.14c2.08,1.79,1.35,1.11,3.28,3.83l-.58-.69Zm-5.5-4.75a3.85,3.85,0,0,1,1.25.59h0c1.46.84,2.24,2.06,3.56,3.56a57.72,57.72,0,0,0-4.81-4.15Zm-2.09-.06c1.65-.61,1.66,0,4.84,2.5a33.29,33.29,0,0,1-4.84-2.5Zm-20.12-4.73,3.66-1.1c-.65,1.2-.46.59-.59,2.36l-.12-.14-3,.23v-1.34Zm7.45,52.48-3.66,1.1c.65-1.2.46-.6.59-2.36l.11.14,3-.23,0,1.34Zm-8.88,2.53,4.13.31c-2.74.2-1.74.17-5-.38l.9.07Zm7.25-.54a3.68,3.68,0,0,1-1.3.48h0c-1.63.43-3,.12-5,0a56.35,56.35,0,0,0,6.34-.48Zm1.52-1.43c-.73,1.6-1.2,1.14-5.19,1.66a35.05,35.05,0,0,1,5.19-1.66Zm1.54-55.57-4.13-.31c2.74-.2,1.74-.17,5,.38l-.9-.07Zm-7.25.54a3.68,3.68,0,0,1,1.3-.48h0c1.62-.43,3-.12,5,0a56,56,0,0,0-6.34.48Zm-1.52,1.42c.73-1.59,1.2-1.14,5.19-1.65a33.91,33.91,0,0,1-5.19,1.65Zm-22.63,30.53-1.1-3.66c1.2.65.6.46,2.37.59l-.15.12.23,3-1.34,0v0Zm-2.52-8.88-.32,4.13c-.2-2.73-.16-1.73.39-5l-.07.89Zm.53,7.26a3.53,3.53,0,0,1-.47-1.31h0c-.43-1.62-.12-3,0-5a56.34,56.34,0,0,0,.47,6.35Zm1.43,1.51c-1.59-.72-1.14-1.2-1.66-5.18a32.39,32.39,0,0,1,1.66,5.18Zm55.57,1.54.32-4.13c.2,2.74.16,1.74-.39,5l.07-.9Zm-.53-7.25a3.72,3.72,0,0,1,.47,1.31h0c.44,1.62.13,3,0,5a56.34,56.34,0,0,0-.47-6.35Zm-1.43-1.52c1.59.73,1.14,1.21,1.65,5.19a33.22,33.22,0,0,1-1.65-5.19Zm-1.48-4.2,1.66,3.43c-1.29-.45-.66-.36-2.43-.2l.13-.14-.7-2.89,1.33-.23v0ZM323.8,180l3.62,1.25c-1.23.6-.72.22-1.86,1.58l0-.19L323,181.09l.77-1.1ZM288,191.07l1.25-3.61c.59,1.22.21.72,1.57,1.86h-.18l-1.55,2.53-1.1-.77v0Zm46.87,24.74-1.25,3.61c-.6-1.23-.21-.72-1.57-1.86h.18l1.55-2.53,1.1.77v0Zm-3.16,8.68,2.68-3.16c-1.45,2.33-.89,1.5-3.26,3.84l.58-.68Zm3.82-6.19a3.66,3.66,0,0,1-.38,1.33h0c-.6,1.57-1.68,2.54-3,4.09a56.7,56.7,0,0,0,3.34-5.42Zm-.27-2.07c.87,1.53.22,1.64-1.69,5.18a32.53,32.53,0,0,1,1.69-5.18Zm-44.1-33.83-2.68,3.15c1.44-2.33.88-1.5,3.26-3.84l-.58.69Zm-3.82,6.18a3.47,3.47,0,0,1,.38-1.33h0c.61-1.57,1.68-2.53,3-4.08a56.61,56.61,0,0,0-3.33,5.42Zm.26,2.07c-.86-1.53-.21-1.65,1.7-5.18a32.93,32.93,0,0,1-1.7,5.18Zm11.46,36.23-3.61-1.26c1.23-.59.72-.21,1.86-1.57l0,.19,2.53,1.55-.78,1.1Zm-8.67-3.16,3.16,2.67c-2.34-1.44-1.51-.88-3.85-3.26l.69.59Zm6.18,3.81a3.64,3.64,0,0,1-1.33-.37h0c-1.57-.6-2.53-1.68-4.08-3a54.51,54.51,0,0,0,5.41,3.33Zm2.07-.26c-1.52.86-1.64.22-5.17-1.7a33.54,33.54,0,0,1,5.17,1.7Zm33.84-44.11-3.16-2.68c2.34,1.45,1.51.89,3.84,3.26l-.68-.58Zm-6.19-3.82a3.76,3.76,0,0,1,1.34.38h0c1.57.6,2.53,1.68,4.08,3a55.48,55.48,0,0,0-5.42-3.34Zm-2.06.27c1.52-.87,1.64-.22,5.17,1.7a33.54,33.54,0,0,1-5.17-1.7Zm-20.62-1.49,3.44-1.67c-.45,1.29-.36.66-.21,2.43l-.14-.12-2.88.69-.23-1.32Zm15.65,50.64-3.44,1.67c.45-1.29.36-.66.21-2.43l.13.12,2.89-.69.23,1.32Zm-8.37,3.9,4.13-.34c-2.68.63-1.69.44-5,.41l.89-.07ZM318,231a3.49,3.49,0,0,1-1.21.68h0c-1.54.69-3,.61-5,.8A55,55,0,0,0,318,231Zm1.28-1.64c-.47,1.69-1,1.31-4.86,2.45a32,32,0,0,1,4.86-2.45ZM312,174.22l-4.13.34c2.67-.63,1.69-.44,5-.41l-.89.07Zm-7.08,1.67a3.74,3.74,0,0,1,1.21-.67h0c1.54-.69,3-.61,5-.8a58,58,0,0,0-6.19,1.47Zm-1.27,1.65c.47-1.69,1-1.31,4.86-2.45a32,32,0,0,1-4.86,2.45Zm-17.52,33.72-1.67-3.44c1.29.45.67.36,2.43.21l-.12.14.7,2.89-1.33.23v0Zm-3.89-8.36.33,4.12c-.63-2.67-.43-1.69-.41-5l.08.9Zm1.67,7.07a3.49,3.49,0,0,1-.68-1.21h0c-.69-1.54-.6-3-.79-5a55.1,55.1,0,0,0,1.47,6.19Zm1.65,1.27c-1.69-.46-1.32-1-2.46-4.86a34,34,0,0,1,2.46,4.86ZM340.65,204l-.34-4.12c.63,2.67.44,1.69.42,5l-.08-.9ZM339,196.91a3.47,3.47,0,0,1,.67,1.21h0c.68,1.54.6,3,.79,5a57.38,57.38,0,0,0-1.47-6.19Zm-1.65-1.28c1.69.47,1.32,1,2.46,4.86a33,33,0,0,1-2.46-4.86Zm-2.11-3.87,2.19,3.13c-1.34-.24-.71-.25-2.43.18l.1-.16-1.14-2.74,1.27-.43v0ZM320,178.36l3.77.67c-1.12.78-.68.32-1.6,1.84l0-.18-2.74-1.13.59-1.21Zm-33.64,16.52.67-3.76c.78,1.12.33.68,1.85,1.59l-.18,0-1.14,2.74-1.2-.59v0ZM336.52,212l-.68,3.76c-.78-1.12-.32-.68-1.84-1.59l.18,0,1.14-2.75,1.2.6v0Zm-1.77,9.06,2.15-3.54c-1.06,2.53-.64,1.63-2.62,4.31l.47-.77Zm2.8-6.71a3.48,3.48,0,0,1-.16,1.38h0c-.35,1.65-1.26,2.76-2.28,4.49a53,53,0,0,0,2.44-5.87Zm-.58-2c1.09,1.38.47,1.59-.87,5.38a33.23,33.23,0,0,1,.87-5.38Zm-48.85-26.53L286,189.36c1.06-2.54.64-1.63,2.62-4.31l-.47.77Zm-2.81,6.7a3.66,3.66,0,0,1,.17-1.37h0c.34-1.65,1.26-2.77,2.28-4.5a56.78,56.78,0,0,0-2.45,5.87Zm.59,2c-1.09-1.37-.48-1.58.87-5.37a33.11,33.11,0,0,1-.87,5.37Zm17,34-3.77-.67c1.12-.78.68-.33,1.59-1.85l.05.19,2.74,1.13-.59,1.21Zm-9.07-1.77,3.54,2.16c-2.53-1.07-1.62-.65-4.31-2.63l.77.47Zm6.71,2.81a3.5,3.5,0,0,1-1.38-.17h0c-1.64-.35-2.76-1.27-4.49-2.29a55.88,55.88,0,0,0,5.87,2.45Zm2-.58c-1.37,1.09-1.59.47-5.38-.88a32.21,32.21,0,0,1,5.38.88Zm26.54-48.85L325.52,178c2.53,1.06,1.62.64,4.3,2.62l-.76-.46Zm-6.71-2.81a3.68,3.68,0,0,1,1.38.16h0c1.64.35,2.76,1.27,4.49,2.29a55.88,55.88,0,0,0-5.87-2.45Zm-2,.58c1.37-1.09,1.58-.47,5.38.87a32.16,32.16,0,0,1-5.38-.87Zm-20.6,1.75,3.14-2.18c-.24,1.34-.25.71.17,2.43l-.15-.1-2.74,1.14-.44-1.28Zm23.37,47.58L320,229.41c.24-1.34.25-.71-.18-2.43l.16.1,2.74-1.14.44,1.27,0,0Zm-7.66,5.16,4-1c-2.55,1-1.61.7-4.9,1.2l.87-.21Zm6.73-2.76a3.85,3.85,0,0,1-1.09.85h0c-1.41.91-2.85,1.06-4.8,1.56a57.83,57.83,0,0,0,5.89-2.42Zm1-1.83c-.2,1.74-.79,1.46-4.42,3.18a33.57,33.57,0,0,1,4.42-3.18Zm-15.78-53.31-4,1c2.55-1,1.61-.69,4.9-1.19l-.87.21Zm-6.73,2.76a3.44,3.44,0,0,1,1.09-.85h0c1.41-.91,2.85-1.06,4.79-1.56a57.66,57.66,0,0,0-5.88,2.42Zm-1,1.83c.2-1.74.79-1.46,4.42-3.19a32.72,32.72,0,0,1-4.42,3.19Zm-12,36L285.46,212c1.34.24.71.25,2.43-.18l-.1.16,1.14,2.74-1.27.43v0Zm-5.16-7.66,1,4c-1-2.54-.7-1.6-1.19-4.9l.21.87Zm2.76,6.73a3.47,3.47,0,0,1-.86-1.09h0c-.92-1.41-1.06-2.85-1.56-4.79a53.45,53.45,0,0,0,2.42,5.88Zm1.83,1c-1.75-.19-1.46-.79-3.19-4.41a34.44,34.44,0,0,1,3.19,4.41Zm53.3-15.78-1-4c1,2.54.7,1.6,1.19,4.9l-.21-.88Zm-2.76-6.72a3.62,3.62,0,0,1,.86,1.09h0c.92,1.41,1.06,2.84,1.56,4.79a52.65,52.65,0,0,0-2.42-5.88Zm-1.83-1c1.74.19,1.46.79,3.19,4.41a33.25,33.25,0,0,1-3.19-4.41Zm-2.73-3.57,2.66,2.75c-1.36,0-.74-.13-2.37.56l.07-.17-1.56-2.53,1.19-.63v0Zm-17.16-10.8,3.82.06c-1,1-.62.43-1.28,2.08l-.07-.18-2.89-.68.39-1.29ZM285.31,199l.07-3.83c.94,1,.42.63,2.07,1.28l-.17.07-.69,2.89-1.28-.39v0Zm52.25,8.92-.07,3.82c-.95-1-.43-.62-2.07-1.28l.17-.07.69-2.88,1.28.39v0Zm-.31,9.23,1.57-3.84c-.65,2.67-.38,1.71-1.91,4.67l.34-.83Zm1.71-7.07a3.57,3.57,0,0,1,.05,1.39h0c-.09,1.68-.81,2.93-1.55,4.8a54.67,54.67,0,0,0,1.49-6.19Zm-.9-1.88c1.3,1.18.72,1.49,0,5.44a32.92,32.92,0,0,1,0-5.44Zm-52.45-18.43-1.56,3.83c.65-2.66.38-1.7,1.9-4.66l-.34.83Zm-1.7,7.07a3.59,3.59,0,0,1-.05-1.39h0c.08-1.68.81-2.93,1.54-4.8a56.86,56.86,0,0,0-1.48,6.19Zm.89,1.88c-1.29-1.18-.71-1.49,0-5.45a33.08,33.08,0,0,1,0,5.45ZM307,229.56l-3.82-.06c1-.95.62-.43,1.28-2.08l.07.18,2.89.68-.4,1.29Zm-9.22-.3,3.83,1.56c-2.67-.64-1.71-.37-4.67-1.9l.84.34Zm7.06,1.7a3.53,3.53,0,0,1-1.38.06h0c-1.67-.08-2.92-.81-4.79-1.54a56.69,56.69,0,0,0,6.18,1.48Zm1.88-.89c-1.17,1.29-1.49.72-5.44,0a33,33,0,0,1,5.44,0Zm18.43-52.45-3.83-1.56c2.67.64,1.71.37,4.67,1.9l-.84-.34Zm-7.06-1.71a3.53,3.53,0,0,1,1.38,0h0c1.68.08,2.93.81,4.8,1.54a56.73,56.73,0,0,0-6.18-1.49Zm-1.89.9c1.18-1.3,1.5-.72,5.45,0a33.08,33.08,0,0,1-5.45,0Zm-20.05,5,2.75-2.65c0,1.36-.14.74.56,2.37l-.17-.08L296.73,183l-.63-1.18,0,0Zm30.63,43.26L324,227.72c0-1.36.14-.74-.56-2.37l.17.07,2.53-1.55.63,1.18,0,0ZM320,231.38l3.82-1.61c-2.35,1.43-1.47.94-4.65,1.95l.83-.34Zm6.21-3.8a3.52,3.52,0,0,1-1,1h0c-1.24,1.13-2.64,1.49-4.48,2.3a57.22,57.22,0,0,0,5.43-3.33Zm.69-2c.08,1.75-.55,1.57-3.85,3.85a32.54,32.54,0,0,1,3.85-3.85ZM302.86,175.5,299,177.11c2.34-1.43,1.47-.94,4.64-2l-.82.35Zm-6.21,3.79a3.49,3.49,0,0,1,1-1h0c1.24-1.13,2.64-1.5,4.48-2.3a59.26,59.26,0,0,0-5.43,3.32Zm-.69,2c-.09-1.75.54-1.56,3.85-3.85a32.54,32.54,0,0,1-3.85,3.85Zm-6.15,37.5L287.15,216c1.36,0,.74.13,2.37-.57l-.07.18,1.56,2.52-1.19.63ZM283.5,212l1.6,3.81c-1.43-2.34-.94-1.47-2-4.64l.35.83Zm3.79,6.2a3.62,3.62,0,0,1-1-.94h0c-1.13-1.25-1.5-2.64-2.3-4.48a53.85,53.85,0,0,0,3.32,5.42Zm2,.7c-1.75.08-1.56-.55-3.84-3.86a33.36,33.36,0,0,1,3.84,3.86Zm50.12-24.06L337.76,191c1.43,2.35.94,1.48,2,4.65l-.35-.83Zm-3.79-6.2a3.62,3.62,0,0,1,1,.94h0c1.13,1.25,1.5,2.64,2.3,4.48a55.75,55.75,0,0,0-3.32-5.42Zm-2-.7c1.74-.08,1.56.55,3.84,3.86a33.36,33.36,0,0,1-3.84-3.86Zm-22-11,3.78-.55c-.81,1.09-.54.52-.93,2.25l-.09-.16-3-.21.18-1.33Zm-26.7,26.3-.55-3.78c1.09.82.53.54,2.25.93l-.15.1-.21,3-1.34-.19v0Zm53,.4.55,3.78c-1.09-.82-.52-.54-2.25-.93l.16-.1.21-3,1.33.18v0Zm1.19,9.15.93-4c-.21,2.73-.1,1.74-1.13,4.91l.2-.88Zm.55-7.25a3.79,3.79,0,0,1,.27,1.36h0c.18,1.67-.33,3-.75,5a58.59,58.59,0,0,0,.47-6.35Zm-1.19-1.71c1.47,1,.95,1.36.87,5.37a32.91,32.91,0,0,1-.87-5.37Zm-54.73-9.74-.93,4c.21-2.73.1-1.74,1.13-4.91l-.2.88Zm-.55,7.25a3.55,3.55,0,0,1-.27-1.36h0c-.19-1.68.33-3,.75-5a56.16,56.16,0,0,0-.47,6.35Zm1.19,1.71c-1.47-1-.95-1.36-.87-5.38a34.15,34.15,0,0,1,.87,5.38Zm26.85,26.89-3.79.55c.82-1.09.55-.52.93-2.25l.1.16,3,.21-.18,1.33Zm-9.16,1.19,4,.92c-2.74-.21-1.75-.09-4.92-1.12l.88.2Zm7.25.54A3.55,3.55,0,0,1,308,232h0c-1.67.19-3-.33-5-.75a55.82,55.82,0,0,0,6.34.47Zm1.72-1.19c-1,1.47-1.37,1-5.38.88a33,33,0,0,1,5.38-.88Zm9.74-54.73-4-.92c2.74.21,1.74.09,4.91,1.12l-.87-.2Zm-7.25-.54a3.55,3.55,0,0,1,1.36-.28h0c1.67-.19,3,.32,5,.75a56,56,0,0,0-6.34-.47Zm-1.72,1.19c1-1.47,1.36-1,5.38-.88a33,33,0,0,1-5.38.88Zm-19,8.16,2.29-3.06c.2,1.35,0,.75.94,2.25l-.19-.05-2.24,2-.81-1.07v0ZM330,222.32l-2.28,3.06c-.2-1.35,0-.75-.94-2.25l.18.05,2.24-2,.82,1.07,0,0Zm-5.63,7.31,3.51-2.2c-2.09,1.79-1.3,1.16-4.27,2.68l.76-.48Zm5.51-4.74a3.58,3.58,0,0,1-.77,1.15h0c-1,1.32-2.37,1.9-4.06,3a55.8,55.8,0,0,0,4.82-4.15Zm.37-2c.36,1.71-.29,1.63-3.18,4.42a32.42,32.42,0,0,1,3.18-4.42Zm-31.81-45.59-3.51,2.2c2.08-1.79,1.3-1.17,4.27-2.68l-.76.48ZM293,182a3.53,3.53,0,0,1,.76-1.16h0c1-1.31,2.37-1.91,4.06-3A55.8,55.8,0,0,0,293,182Zm-.37,2c-.37-1.72.29-1.63,3.18-4.42a33.31,33.31,0,0,1-3.18,4.42Zm0,38-3.07-2.29c1.35-.19.75,0,2.25-.93l0,.18,1.94,2.24-1.07.82v0Zm-7.32-5.64,2.2,3.51c-1.79-2.08-1.16-1.3-2.68-4.27l.48.76Zm4.74,5.51a3.49,3.49,0,0,1-1.15-.76h0c-1.31-1.05-1.9-2.36-3-4.05a54.21,54.21,0,0,0,4.15,4.81Zm2,.38c-1.71.36-1.63-.29-4.41-3.19a33.07,33.07,0,0,1,4.41,3.19Zm45.59-31.82-2.19-3.5c1.78,2.08,1.16,1.3,2.67,4.27l-.48-.77ZM332.88,185a3.62,3.62,0,0,1,1.16.77h0c1.32,1.05,1.91,2.36,3,4.05a57.72,57.72,0,0,0-4.16-4.82Zm-2.05-.37c1.72-.36,1.63.29,4.42,3.19a33.15,33.15,0,0,1-4.42-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M335,203.44A23.58,23.58,0,1,0,311.43,227,23.58,23.58,0,0,0,335,203.44Zm-5,0A18.57,18.57,0,1,0,311.43,222,18.56,18.56,0,0,0,330,203.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M332.24,203.44a20.81,20.81,0,1,0-20.81,20.8,20.81,20.81,0,0,0,20.81-20.8Zm-4.32,0a16.49,16.49,0,1,0-16.49,16.48,16.48,16.48,0,0,0,16.49-16.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M329.42,203.44a18,18,0,1,0-5.27,12.72,17.9,17.9,0,0,0,5.27-12.72Zm-4.81-13.18a18.64,18.64,0,1,1-13.18-5.46,18.55,18.55,0,0,1,13.18,5.46Zm3,13.18a16.15,16.15,0,1,0-4.73,11.42,16.15,16.15,0,0,0,4.73-11.42Zm-4.27-11.89a16.82,16.82,0,1,1-11.89-4.92,16.79,16.79,0,0,1,11.89,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M329.75,203.44a18.32,18.32,0,1,0-18.32,18.31,18.32,18.32,0,0,0,18.32-18.31Zm-1.83,0a16.49,16.49,0,1,0-16.49,16.48,16.48,16.48,0,0,0,16.49-16.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M316.92,203.44a5.49,5.49,0,1,1-5.49-5.49A5.49,5.49,0,0,1,316.92,203.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M332.24,204c0-.09,0-.18,0-.27a20.8,20.8,0,0,1-41.59,0c0,.09,0,.18,0,.27a20.81,20.81,0,0,0,41.61,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M332.24,203.44c0,.09,0,.18,0,.28a20.8,20.8,0,0,0-41.59,0c0-.1,0-.19,0-.28a20.81,20.81,0,0,1,41.61,0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "COLOUR",
    className: "cls-72",
    d: "M162.25,173.61l-45.17-22.67s-4.59-3-6.22-7.24-3.31-9.22-3.31-9.22,5.48-2.62,19.7-3.16,42.74,5.76,54,14.22,25.1,26.9,25.1,26.9S195.27,171,190.41,171s-19.35-1.53-21.41,2.34-6.75.27-6.75.27Zm101.56-63.19-3.19,1.8c-2-1.26-5.83-3.66-7.26-4.54-2-1.22-4.22-1.37-5.69-2s-.46-1.77,1.12-2.48a13.93,13.93,0,0,0,2.69-1.63,13.05,13.05,0,0,0-3.86-2.54,28.58,28.58,0,0,0-5.28-1.52,4.16,4.16,0,0,1,1-3.76A12.32,12.32,0,0,1,246.76,91L248,88.29l15.45,1.83.05,1-2.08,1.73s-1.12,2.13.71,3.4a11.68,11.68,0,0,1,4.26,5.59,8,8,0,0,0,2.59,3.9c.91.82,1.63,1.43,1.63,1.43l-4.22,1.26s-2.79-.1-2.59,2Zm21,67.55s5.8-3.12,10.26-2.32,13.51,6.6,13.51,6.6a4.44,4.44,0,0,0,1.47-1c.85-.8,2.5-3.67,6.9-4.46s17.05-1,17.05-1,2.07-.6.31-1.34c-6.06-8.55-16.78-14.3-35.49-15.25a10.71,10.71,0,0,1,6.81-2.19c1.87-.19,5.89-7.57,5.89-7.57l-9.62-14.57-2.06-.56.1-1.68s-7.66-10.18-31.2-21l-5.88.19-3,1.4-2,3.54s-.75.56.65,2,19.9,24.93,19.9,24.93l-5.7,17.84-1.22,7.28,2.43.1,2.8,5.51,8.75,2.14c-.24.48-.47,1-.71,1.47Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "details"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contour",
    className: "cls-44",
    d: "M308.59,182.71a.52.52,0,0,1-.25-.07c-.09-.06-9-5.77-13.34-6.54a8.58,8.58,0,0,0-1.47-.12c-4,0-8.45,2.37-8.5,2.39a.44.44,0,0,1-.53-.07.44.44,0,0,1-.1-.53l.47-1-8.2-2a.48.48,0,0,1-.3-.24l-2.68-5.27-2.15-.09a.42.42,0,0,1-.34-.17.43.43,0,0,1-.1-.36l1.22-7.29a.13.13,0,0,1,0-.06L278,143.72c-1.77-2.25-18.4-23.4-19.7-24.7a2.64,2.64,0,0,1-1-1.89,1.08,1.08,0,0,1,.29-.68l1.93-3.49a.46.46,0,0,1,.2-.19l.55-.25c-2.14-1.34-5.74-3.6-7.12-4.45a12.76,12.76,0,0,0-3.69-1.36,15.86,15.86,0,0,1-1.93-.58c-.81-.34-1-.83-1-1.19,0-1.1,1.61-1.92,2.11-2.14a14,14,0,0,0,2.16-1.25,13.19,13.19,0,0,0-3.32-2.07,27.93,27.93,0,0,0-5.18-1.5.46.46,0,0,1-.36-.31,4.57,4.57,0,0,1,1.06-4.2,12.64,12.64,0,0,1,3.44-2.77l1.2-2.6a.45.45,0,0,1,.47-.27l15.44,1.83a.47.47,0,0,1,.41.43l.05,1a.46.46,0,0,1-.17.38l-2,1.66a2.14,2.14,0,0,0,.6,2.73,12.21,12.21,0,0,1,4.43,5.8,7.61,7.61,0,0,0,2.44,3.71l1.64,1.44a.47.47,0,0,1,.16.44.47.47,0,0,1-.32.35l-4.21,1.27a.39.39,0,0,1-.15,0h-.05a2.68,2.68,0,0,0-1.82.59,1.11,1.11,0,0,0-.25.89.46.46,0,0,1-.23.45l-.87.49,5.57-.18a.41.41,0,0,1,.21,0c23.37,10.76,31.29,21,31.36,21.15a.44.44,0,0,1,.09.31l-.07,1.31,1.7.46a.46.46,0,0,1,.26.19l9.62,14.57a.47.47,0,0,1,0,.47c-.69,1.27-4.23,7.6-6.24,7.8q-.42,0-.84.06a9,9,0,0,0-4.58,1.31c16.53,1.07,27.78,6.07,34.35,15.25.32.14.9.46.87,1s-1,1-1.35,1.13l-.12,0c-.13,0-12.66.25-17,1A9.77,9.77,0,0,0,311,181a8.19,8.19,0,0,1-.58.64,4.7,4.7,0,0,1-1.65,1.08l-.13,0Zm-15.06-7.65a10.55,10.55,0,0,1,1.63.13c4.18.75,12.07,5.65,13.47,6.54a4.71,4.71,0,0,0,1.11-.8,6.35,6.35,0,0,0,.51-.56,10.72,10.72,0,0,1,6.63-4c4.27-.78,16-1,17.06-1.05a2.17,2.17,0,0,0,.57-.27,2.85,2.85,0,0,0-.37-.19.45.45,0,0,1-.2-.16c-6.57-9.26-18.06-14.18-35.13-15.05a.45.45,0,0,1-.42-.33.43.43,0,0,1,.18-.5,10.35,10.35,0,0,1,6.23-2.22l.8-.06c1.09-.11,3.75-4.13,5.39-7.09l-9.37-14.19-1.89-.51a.47.47,0,0,1-.34-.47l.09-1.51c-1-1.21-9.17-10.72-30.82-20.7l-5.68.18-2.77,1.3L258.32,117a.24.24,0,0,1-.12.14c-.06.07-.1.48.7,1.27,1.4,1.41,19.17,24,19.93,25a.45.45,0,0,1,.07.42l-5.68,17.81-1.12,6.73,1.9.08a.43.43,0,0,1,.39.25L277.1,174l8.54,2.09a.45.45,0,0,1,.31.26.41.41,0,0,1,0,.39c0,.1-.09.19-.13.28a20.43,20.43,0,0,1,7.72-1.92ZM242.72,97.13a28,28,0,0,1,5.08,1.5,13.52,13.52,0,0,1,4,2.64.49.49,0,0,1,.13.35.47.47,0,0,1-.17.33,13.86,13.86,0,0,1-2.79,1.69c-1.09.48-1.57,1-1.56,1.29s.16.24.43.35a12.2,12.2,0,0,0,1.8.53,13.93,13.93,0,0,1,3.95,1.48l7,4.39,2.71-1.52a1.94,1.94,0,0,1,.5-1.29,3.61,3.61,0,0,1,2.5-.89l3.34-1-1-.88A8.41,8.41,0,0,1,266,102a11.24,11.24,0,0,0-4.1-5.37,3.07,3.07,0,0,1-.85-4,.4.4,0,0,1,.11-.14L263,90.93l0-.4-14.73-1.75-1.12,2.44a.47.47,0,0,1-.21.23,11.61,11.61,0,0,0-3.31,2.62,3.79,3.79,0,0,0-.93,3.06Zm-76.54,78.46A8,8,0,0,1,162,174l-45.13-22.65,0,0c-.2-.12-4.74-3.14-6.4-7.45s-3.3-9.19-3.32-9.24a.46.46,0,0,1,.24-.56c.23-.11,5.73-2.67,19.88-3.21.57,0,1.17,0,1.79,0,15.14,0,41.92,6.4,52.49,14.34,11.17,8.4,25.05,26.81,25.19,27a.45.45,0,0,1,0,.51.47.47,0,0,1-.46.23c-.11,0-11.09-1.44-15.86-1.44-.92,0-2.16-.05-3.61-.11-2-.09-4.26-.19-6.56-.19-6.34,0-10,.81-10.84,2.4a3.51,3.51,0,0,1-3.22,2Zm-48.87-25.05,45.14,22.66.08,0a7.19,7.19,0,0,0,3.65,1.43,2.59,2.59,0,0,0,2.41-1.55c1-2,4.75-2.88,11.65-2.88,2.32,0,4.6.1,6.6.19,1.44.06,2.67.11,3.57.11,3.93,0,12,1,14.89,1.31-2.9-3.76-14.67-18.67-24.34-25.94C170.53,138.06,144,131.75,129,131.75c-.61,0-1.2,0-1.76,0-11.91.46-17.68,2.39-19.14,3,.43,1.28,1.82,5.32,3.16,8.79,1.51,3.9,5.7,6.79,6,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M221.1,148.2l-31.33,4.12s-10.53-11.4-32.12-15-24.57-3.86-24.57-3.86l-8.6-1.94,3.86-7.89s-.35-2.11,9.22-1.23,32.2,4.21,32.2,4.21,6.32,6.32,20.19,5.09,22.82-1.84,22.82-1.84a5.64,5.64,0,0,1,4.3,1.23c2.1,1.66,5.79,4.91,5.79,4.91a13.69,13.69,0,0,1,3.6,5.09c1.31,3.25.7,4.3.7,4.3l-6.06,2.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "details-2",
    "data-name": "details"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M242.24,97a4.07,4.07,0,0,1,0-1c6.1.42,9.9,2.75,11.37,4.77s-1.06.51-4.09-1.61c-2.18-1.53-5.59-2-7.32-2.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M254.46,127.3l.3.61,2,.07,4.69.12c1.65.28,3,1.48,4.25,3.33l2.37,3.91,2,3.87,1.29,3.13.58,1.67.21,1.64-.21,2.09-.39,2.67-.49,2.88-.46,2.73a2.66,2.66,0,0,1-.35.77,3.18,3.18,0,0,0,.81-1.36l.46-2.73.49-2.88.39-2.67.21-2.09-.21-1.64-.58-1.67-1.29-3.13-2-3.87-2.37-3.9c-1.21-1.85-2.59-3.06-4.25-3.34l-4.69-.12-2.73-.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M174.23,187.87h0l8.49,8.65a17.41,17.41,0,0,1,4.4,3.61c2.05,2.36-.94,4.41,3,5.19s23,5.82,41.52,5.82a169.2,169.2,0,0,0,32.25-2.67c3.93-.63,4.87-1.26,6.76-3.93s14.4-26,15.63-28.29l-6.1-1.74s-.7,2-2.6,6.5-6.7,9.71-12.11,15.11-17.41,3-17.41,3l-39.72-4.2-24.51-5.5-9.6-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M174.23,187.87h0l.65.66c4.91,1.61,20.06,6.51,27.05,8.09,8.4,1.9,24.81,3.5,32.21,4s24.42,3.71,30.82-.6,11.51-13.71,13.41-17.51a10.66,10.66,0,0,1,7.5-5.52l.4-.74-6.1-1.74s-.7,2-2.6,6.5-6.7,9.71-12.11,15.11-17.41,3-17.41,3l-39.72-4.2-24.51-5.5-9.6-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M119.54,152.17l-2.46-1.23s-4.23-3.06-5.4-7.29a44,44,0,0,1-1.34-8.3c.39-.48.56-.72.41-.61h0c3.2,1.28,8.67,2.67,18,3.83,24.33,3,38.16,5.25,45.94,10.8,7,5,24.11,18.34,31.13,23h.55S184,164.56,175.79,162.1c-6.43-1.94-36.78-8.41-56.25-9.93Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M110.75,134.74c1.18-.86,5.21-3,16.5-3.42,14.21-.54,42.74,5.76,54,14.22s25.1,26.9,25.1,26.9l-.55-.07c-7-4.66-24.16-18-31.13-23-7.78-5.55-21.61-7.77-45.94-10.8-9.29-1.16-14.76-2.55-18-3.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M145.51,140.76s13.73,1.09,21.59,3.83S184,156.14,184,156.14a92.66,92.66,0,0,0-38.51-15.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M169.52,145.83c3.42,1.53,6.06,3.07,5.9,3.44s-3.08-.56-6.5-2.09-6.06-3.06-5.9-3.43S166.1,144.31,169.52,145.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M110.8,134.71l4,2.67s-4.27,8,11.13,16.24,37.42,19,37.42,19,2.34,2.26,3.85-.67,6.28-7.79,38.3.39c-2.63-.33-11.06-1.34-15.13-1.34-4.86,0-19.35-1.53-21.42,2.34s-6.74.27-6.74.27l-45.17-22.67s-4.23-3.06-5.4-7.29a43.29,43.29,0,0,1-1.35-8.55,2.85,2.85,0,0,1,.47-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M121,152.91a83.11,83.11,0,0,1,10.49.43c5.6.74,4.7.89,4.7.89s-.33,2.6,2.5,7.56L121,152.91Zm40.48,20.32c-.88-1.67-.89-3.23.9-4.23,5.6-3.11,18.25-2.06,28.64,2h-.62c-4.86,0-19.35-1.53-21.42,2.34s-6.74.27-6.74.27l-.76-.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M204.94,150.48c8-1,14.5-1.37,14.57-.8s-6.33,1.87-14.3,2.88-14.49,1.36-14.57.79S197,151.49,204.94,150.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M125.27,129.9l3.07-6.27a.37.37,0,0,1,0-.14c5.8,1,20.31,3.7,31.4,6.26,14.18,3.26,28.19,9.19,32.23,10.83s.94,2.14,0,3.61.08,2.66-.69,4.29-6.62-2.66-14.95-7c-8-4.23-30.8-8.54-51.07-11.54Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M194.14,141.17a12.6,12.6,0,0,0,5.83,2c3.35.22,14.14.66,15.59-1.31s-2-8.52-2-8.52,16.61,10,9.32,10.92-28.34,4.45-28.78-3.05Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M169,175.44s4-3.57,14.57-1.91,19.91,7.82,23.86,11.13a38.39,38.39,0,0,1,6,6.24l6.17-1-11.32-15.4-2.1-2.1s-9.65-.66-19.34-1-19.24-.4-17.88,4.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M174.66,187a8.29,8.29,0,0,1,2-2.25c1.05-.67,2.39-.72,4.74-.33s13,2.63,13,2.63l-15.74-3.73s-1.48-.72-2.3.24-2.44,2.92-2.44,2.92l.72.52Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M168.68,174.85a2.92,2.92,0,0,0-.63,3.2,88.2,88.2,0,0,0,5.37,7.42l2.05-2.49s.38-1.34,2.35-.95,15.74,3.59,15.74,3.59l2.16-.58,12.87,3.11,1.39,1.68,2.72.67s-3-6.51-16.31-12.45-21.06-6.17-27.71-3.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-90"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M188.71,186.49s12.39,2.94,17.64,3.88a254.8,254.8,0,0,0,30.54,4c15.75,1.16,21,4.2,28.14-2.73S276.47,174,276.47,174l3.25.42s-7.56,16-13.54,20.26S263,199,243.4,197.83c-7.26-.43-18.43-1-27.5-2.32-15.46-2.26-28-5.55-28-5.55l.84-3.47Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M274.15,169.17l2.63,5.19,9.16,2.24s2.05.65,2.61-2.34,5.42-11.3,9.34-14.38,5.88-2.71,7.75-2.89,5.89-7.57,5.89-7.57l-.07-.1a33.93,33.93,0,0,1-7.34-.83s-1.48,5.58-3,7.39-5.5,4.33-7.55,7.23-3.37,5-6.78,6.86-11.65-.6-11.65-.6l-1-.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M262.9,123l17,20.15-5.57,18.4-1.3,7.21,1.19.17a40,40,0,0,0,5.39-4.71,22.88,22.88,0,0,0,4-7.9c1-3.35,2.56-11.18,2.56-11.18s.22-.46-.74-1.48-16.24-17.26-16.24-17.26a11.22,11.22,0,0,0-6.36-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M279.85,143.42l-5.48,18.11-.61,3.36a43.94,43.94,0,0,1,1.93-5.39c1.41-3.1,4.83-15.32,4.83-15.32l-.67-.76Zm-.41,21a2.25,2.25,0,0,0,.21-.24,22.88,22.88,0,0,0,4-7.9c1-3.35,2.56-11.18,2.56-11.18a.55.55,0,0,0,0-.34l-.71.43s-2.23,8.69-2.72,11.08a54.63,54.63,0,0,1-3.36,8.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M274.18,162.57l-1.11,6.17,1.19.17a42.13,42.13,0,0,0,5.21-4.5,16.48,16.48,0,0,0,1.23-3.27s-4-.25-5.12-.42c-.56-.08-1,.86-1.4,1.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "269.56 126.11 283.84 141.39 286.39 144.45 286.96 144.53 284.23 141.06 269.56 126.11 269.56 126.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M282,161.29a12,12,0,0,1-2,3.2c-1,.91-4.44,3.29-2.48,3.53s5.3,1.44,7.45,1.34.72-2.53-1.1-3-1.81-1.1-1-2.24,1-2.87-.91-2.82Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M213.12,191.72v-.1l-1.75-.43,1.75.53Zm-1.83-.56Zm0-.19,1.79.44a24,24,0,0,0-3.06-.84c.17.22.66.25,1.27.4Zm-33.67-6.41,1.8-.11a6.47,6.47,0,0,0-1.8.11Zm-4,2.44v0s1.88-3.45,4.31-3.47,14.47,3,15,2.93c1.64-.13.34-1.19,4.93-.06,2.16.54,10,1.87,11.43,3.17l.62.84a22.94,22.94,0,0,0,7.12,1l2.59,0,0-.06c.9.15,4.34.11,4.85-.8l.06-.14,0,0c0,.26,0,.28.1.43,3.94.18,19.58.61,22.14.28l4-1c1.47-.93,6.35-10.34,8-11.4,7.61-4.82,8.38-4.26,16.9-4.6a19.7,19.7,0,0,1,3.78.65v0l0,0v0h0a54.68,54.68,0,0,1-4.46,9.68c-1.86,3.42-5,6.63-7.84,9.32s-1.71,1.72-5.26,4h0c-2.52,1.69-11.08,1.3-14.11,1.12-8.15-.51-17.32-1.27-25.47-2-9.67-.85-14-1.94-23.39-4.16l-2.85-.68h0s-13.07-3.18-16.38-3.42c-.86-.06-5.48-1-5.52-1h0l-.15-.16h0l-.56-.69h0l0,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-97"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M259.21,179.05s2-6.25,2.11-10.69c0-1.35.22-3.33.46-5.52l5.88-3.56c-.23,1.28-.43,2.68-.69,4.34-.81,5.15-.91,7.26-1.61,9.88s-5.15,3.43-6.15,5.55Zm2.65-17c.52-4.83,1.17-10.45.77-12.84a36.81,36.81,0,0,1-.6-4.64,7.22,7.22,0,0,1,6.15-1.71c3.93.6,4.84,4.33,2.32,8.67a21.24,21.24,0,0,0-2.68,6.92l-6,3.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M295,163.85s7.33-2.87,19.19.49,17.66,9.17,12.29,9-9.42.85-12.84,3.42-4.16,5.13-5.44,4.4-3.42-1.77-4.22-3.42-2.2-5-4.64-7-4.95-4.46-4.34-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M295.73,164.15s6.79-2.66,17.78.46,16.36,8.49,11.38,8.38-8.72.79-11.89,3.17-3.86,4.76-5,4.08-3.18-1.64-3.91-3.18-2-4.64-4.31-6.45-4.58-4.13-4-6.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M296.43,164.46s6.25-2.46,16.37.41,15.07,7.82,10.48,7.72-8,.73-10.95,2.92-3.55,4.38-4.64,3.75-2.92-1.51-3.6-2.92-1.88-4.27-4-5.94-4.22-3.81-3.7-5.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M297.13,164.76s5.72-2.24,15,.38,13.78,7.15,9.58,7.05-7.34.67-10,2.67-3.25,4-4.25,3.43-2.67-1.38-3.28-2.67-1.72-3.91-3.63-5.43-3.86-3.48-3.38-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M297.84,165.06s5.17-2,13.55.34,12.47,6.48,8.67,6.39-6.64.6-9.06,2.42-2.94,3.62-3.84,3.11-2.42-1.25-3-2.42-1.56-3.54-3.28-4.92-3.5-3.15-3.06-4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M298.54,165.36s4.64-1.82,12.14.31,11.18,5.8,7.78,5.72-6,.54-8.13,2.17-2.63,3.25-3.44,2.78a6.26,6.26,0,0,1-2.67-2.16,12.2,12.2,0,0,0-2.94-4.41c-1.54-1.24-3.13-2.83-2.74-4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M299.24,165.66s4.1-1.61,10.74.27,9.88,5.13,6.87,5.06-5.27.48-7.18,1.92-2.33,2.87-3,2.46a5.42,5.42,0,0,1-2.36-1.92,10.89,10.89,0,0,0-2.6-3.89c-1.37-1.1-2.77-2.5-2.43-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M299.94,166s3.57-1.39,9.33.24,8.59,4.45,6,4.39a9.52,9.52,0,0,0-6.24,1.67c-1.66,1.25-2,2.49-2.64,2.14a4.8,4.8,0,0,1-2.05-1.67,9.35,9.35,0,0,0-2.26-3.38c-1.19-.95-2.4-2.17-2.11-3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M300.65,166.26s3-1.18,7.92.2,7.28,3.79,5.06,3.74a8,8,0,0,0-5.29,1.41c-1.41,1.06-1.72,2.12-2.25,1.81a4,4,0,0,1-1.74-1.41,7.81,7.81,0,0,0-1.91-2.87c-1-.81-2.05-1.84-1.79-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M301.35,166.56a11,11,0,0,1,6.51.17c4,1.14,6,3.11,4.16,3.07a6.61,6.61,0,0,0-4.35,1.16c-1.16.87-1.41,1.74-1.84,1.49a3.31,3.31,0,0,1-1.43-1.16,6.57,6.57,0,0,0-1.58-2.36c-.83-.67-1.68-1.52-1.47-2.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-109"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M245.51,91.8a10.14,10.14,0,0,1,1.25-.77L248,88.29l15.45,1.83.05,1-2.08,1.73s-1.12,2.13.71,3.4a11.41,11.41,0,0,1,3.28,3.54,10.12,10.12,0,0,1-1.83.09c-4.64-.15-2.67-2.2-9.12-6a14.37,14.37,0,0,0-9-2.08Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M254.15,108.18l-.79-.5c-2-1.22-4.22-1.37-5.69-2-.62-.25-.8-.61-.68-1a3.93,3.93,0,0,0,2.45-.1c1.93-.74,3.54-3,5.86-2.28s5.9,1,7.55,2.16,1.18,1.1,3.14,1a9.2,9.2,0,0,1,3.82,1l.81.7-4.22,1.26s-2.7-.09-2.59,1.89a6.68,6.68,0,0,0-4.07-2.06,21.83,21.83,0,0,0-5.59-.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M268.75,111.6l-5.84.18a12.07,12.07,0,0,0-1.56,3.47c-.32,1.74-.47,1.9-1.58,2.06a16.36,16.36,0,0,1-2,.06,2.66,2.66,0,0,0,.84,1.33c1.1,1.1,12.72,15.82,17.68,22.11,3.24,1.84,7.25,3.83,10,4.24,5.32.8,15.54,2.86,18.24,3.49,1.6.38,5.06,1.15,7,.81l-9.57-14.5-2.06-.56.1-1.68s-7.66-10.18-31.2-21Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M307.4,148.82s-8.57-8.4-11.56-10.64a114.82,114.82,0,0,0-10.17-6.09s7.65,5.34,8.91,6.84,8.8,8.39,8.8,8.39l4,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M262.9,123l16.82,19.34.64.89a4.78,4.78,0,0,0,1.46.89c.57.2,3.22.79,3.22.79a2.07,2.07,0,0,0,1.09-.38,3.42,3.42,0,0,0-.63-.87c-1-1-16.24-17.26-16.24-17.26a11.22,11.22,0,0,0-6.36-3.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M264.48,111.8l-1.61,0-1.11.52a18,18,0,0,1,4.43,1c1.9.83,20.67,13,20.67,13s6.88,4.83,8.16,5.7,2.86,2.53,4.84,2.13l.07-1.22c-.52.15-1.59-.08-3.83-1.63-3.4-2.36-23.47-16.41-31.62-19.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M264.48,111.73l-1.61.06-1.11.52a18,18,0,0,1,4.43,1c1.9.82,20.67,13,20.67,13s6.88,4.82,8.16,5.7,2.86,2.53,4.84,2.13l.07-1.22c-.52.15-1.59-.08-3.83-1.63-3.4-2.36-23.47-16.41-31.62-19.54Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M308.53,202.71s-1.94,1-2,2.26.37,3.81,2.34,4.81a20.37,20.37,0,0,0,5.71,1.34.9.9,0,0,0,.39-1.24c-.43-.8-5-7.48-5-7.48l-1.43.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M301.33,204.4c.08-.75,1.4-.16,1.75,0a10.37,10.37,0,0,0,3.6.73,3.11,3.11,0,0,0,.06,2,20.27,20.27,0,0,1-4.37-.8,3,3,0,0,1-1.24-.48.43.43,0,0,1-.15-.53,6.67,6.67,0,0,0,.35-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M286.84,189.05a48.75,48.75,0,0,1,.47-7.14c.13-1.17.38-2.32.57-3.48.09-.49.17-1,.27-1.45s.94-.58,1.47-.67c-1.14,5.16-2,10.72-1.24,16a13.77,13.77,0,0,0,3,7.17,13.61,13.61,0,0,0,6.12,3.66c1.27.42,2.56.76,3.86,1.1-.12.32-.12.87-.36,1.12s-1-.12-1.37-.23a38.88,38.88,0,0,1-3.79-1.22,14.53,14.53,0,0,1-5.84-4.08c-2.52-3-3-7.05-3.18-10.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "298.58 174.97 297.92 175.32 296.96 175.82 296.02 176.31 295.18 176.75 294.56 177.07 294.23 177.25 293.58 176.01 293.55 175.94 293.88 175.77 294.5 175.45 295.33 175.02 296.29 174.52 297.24 174.02 298.08 173.58 298.38 173.42 298.7 173.26 299.03 173.09 299.71 174.38 299.38 174.56 299.13 174.69 298.75 174.88 298.58 174.97 298.58 174.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "295.84 179.53 295.51 179.7 295.51 179.68 295.51 179.68 295.64 179.37 295.69 179.25 295.98 179.09 296.53 178.81 297.27 178.43 298.1 177.99 298.94 177.55 299.67 177.17 300.22 176.88 300.51 176.73 300.69 176.77 300.99 176.84 300.66 177.01 300.04 177.34 299.2 177.77 298.25 178.27 297.3 178.77 296.46 179.2 295.84 179.53 295.84 179.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "294.52 177.81 294.85 177.63 295.47 177.31 296.31 176.88 297.26 176.38 298.21 175.88 298.92 175.51 299.05 175.44 299.67 175.12 300 174.95 300.69 176.28 300.36 176.45 299.75 176.77 298.91 177.21 297.96 177.71 297 178.2 296.16 178.64 295.54 178.96 295.21 179.14 295.2 179.12 294.52 177.81 294.52 177.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "294.52 177.81 294.71 177.35 295 177.2 295.54 176.92 296.27 176.53 297.11 176.1 297.95 175.66 298.69 175.27 299.23 174.99 299.52 174.84 299.85 174.91 300 174.95 299.67 175.12 299.05 175.44 298.92 175.51 298.21 175.88 297.26 176.38 296.31 176.88 295.47 177.31 294.85 177.63 294.52 177.81 294.52 177.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "294.71 177.35 294.23 177.25 294.56 177.07 295.18 176.75 296.02 176.31 296.96 175.82 297.92 175.32 298.58 174.97 298.75 174.88 299.13 174.69 299.38 174.56 299.71 174.38 299.52 174.84 299.23 174.99 298.69 175.27 297.95 175.66 297.11 176.1 296.27 176.53 295.54 176.92 295 177.2 294.71 177.35 294.71 177.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "293.88 175.77 293.55 175.94 293.65 175.6 293.96 175.45 294.46 175.19 294.73 175.05 294.84 174.99 294.9 174.96 294.9 174.96 294.92 174.95 295.23 174.78 295.3 174.75 295.6 174.59 295.67 174.56 296.17 174.29 296.67 174.03 297.04 173.84 297.11 173.8 297.44 173.63 297.48 173.61 297.56 173.56 297.61 173.54 297.76 173.46 297.81 173.44 298.38 173.14 298.69 172.98 298.97 173.07 299.03 173.09 298.7 173.26 298.38 173.42 298.08 173.58 297.24 174.02 296.29 174.52 295.33 175.02 294.5 175.45 293.88 175.77 293.88 175.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "294.73 175.05 291.39 168.65 291.41 168.61 292.77 166.59 293.53 165.7 297.61 173.54 297.56 173.56 297.48 173.61 297.44 173.63 297.11 173.8 297.04 173.84 296.67 174.03 296.17 174.29 295.67 174.56 295.6 174.59 295.38 174.7 295.3 174.75 295.23 174.78 294.92 174.95 294.9 174.96 294.9 174.96 294.84 174.99 294.73 175.05 294.73 175.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "295.69 179.25 295.22 179.15 295.55 178.97 296.17 178.65 297.01 178.21 297.96 177.72 298.91 177.22 299.57 176.87 299.75 176.78 300.12 176.58 300.37 176.46 300.7 176.28 300.51 176.74 300.22 176.89 299.68 177.17 298.94 177.56 298.1 178 297.27 178.43 296.53 178.81 295.98 179.1 295.69 179.25 295.69 179.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "306.82 200.84 306.82 200.84 307.12 200.68 307.69 200.38 308.46 199.98 309.34 199.52 310.22 199.06 310.99 198.66 311.56 198.37 311.86 198.21 312.52 199.48 312.53 199.48 312.56 199.55 312.69 199.78 312.8 199.99 312.82 200.23 312.9 200.8 312.9 200.83 312.91 200.89 312.93 201.06 312.93 201.06 313.04 201.28 313.76 202.66 313.8 202.73 314.46 203.98 314.54 204.15 314.6 204.26 315.29 205.57 315.02 205.71 314.52 205.97 313.86 206.32 313.09 206.72 312.89 206.82 312.55 207 312.34 207.11 311.67 207.46 311.17 207.72 310.92 207.85 310.38 206.82 309.25 204.66 308.75 203.71 308.67 203.56 308.67 203.55 308.56 203.34 308.55 203.34 308.44 203.25 308.45 203.24 308.49 203.21 308.48 203.18 308.46 203.14 308.43 203.09 308.35 203.02 308.32 203 308.3 203 308.2 202.95 308.15 202.98 307.93 202.79 307.75 202.63 307.64 202.41 307.36 201.88 307.36 201.88 307.36 201.87 306.82 200.84 306.82 200.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "306.91 200.61 307 200.38 307.27 200.25 307.76 199.99 308.44 199.63 309.19 199.24 309.96 198.84 310.62 198.5 311.12 198.24 311.38 198.1 311.86 198.21 311.56 198.37 310.99 198.66 310.22 199.06 309.34 199.52 308.46 199.98 307.69 200.38 307.12 200.68 306.82 200.84 306.91 200.61 306.91 200.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "307 200.38 306.52 200.28 306.83 200.12 307.4 199.82 308.17 199.42 309.05 198.96 309.92 198.5 310.69 198.1 311.26 197.8 311.56 197.65 311.54 197.72 311.38 198.1 311.12 198.24 310.62 198.5 309.96 198.84 309.19 199.24 308.44 199.63 307.76 199.99 307.27 200.25 307 200.38 307 200.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "306.19 198.9 306.76 198.6 307.53 198.2 307.93 197.99 308.41 197.74 309.29 197.28 310.06 196.88 310.63 196.58 310.93 196.43 311.56 197.65 311.26 197.8 310.69 198.1 309.92 198.5 309.05 198.96 308.17 199.42 307.4 199.82 306.83 200.12 306.52 200.28 305.89 199.06 306.19 198.9 306.19 198.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "306.34 198.47 306.83 198.21 307.5 197.86 307.82 197.69 308.27 197.46 309.02 197.06 309.03 197.06 309.69 196.72 310.19 196.46 310.45 196.32 310.93 196.43 310.63 196.58 310.06 196.88 309.29 197.28 308.41 197.74 307.93 197.99 307.53 198.2 306.76 198.6 306.19 198.9 305.89 199.06 306.07 198.6 306.34 198.47 306.34 198.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "295.51 179.7 295.84 179.53 296.46 179.2 297.3 178.77 298.25 178.27 299.2 177.77 300.04 177.34 300.66 177.01 300.99 176.84 301.3 177.43 301.41 177.64 301.44 177.88 301.54 178.47 301.57 178.72 301.58 178.78 301.58 178.78 301.62 179.04 301.63 179.09 301.63 179.1 301.66 179.31 301.68 179.44 301.68 179.44 301.69 179.49 301.7 179.54 301.81 179.76 301.83 179.8 301.87 179.88 301.88 179.89 301.9 179.94 301.91 179.95 302.64 181.35 302.65 181.37 302.74 181.54 302.81 181.68 302.81 181.69 303.71 183.4 303.75 183.48 305.03 185.93 305.12 186.09 305.14 186.13 305.26 186.37 305.29 186.43 305.58 186.98 305.87 187.54 306.03 187.84 307.77 191.18 307.83 191.3 309.91 195.27 310.45 196.32 310.19 196.46 309.69 196.72 309.03 197.06 309.02 197.06 308.27 197.46 307.82 197.69 307.5 197.86 306.83 198.21 306.34 198.47 306.07 198.6 304.61 195.79 304.09 194.79 303.46 193.6 303.46 193.6 303.4 193.48 303.3 193.29 301.65 190.13 301.5 189.84 301.21 189.28 300.92 188.73 300.86 188.62 300.77 188.44 300.73 188.36 300.66 188.24 299.4 185.82 299.36 185.74 297.79 182.73 297.76 182.68 297.69 182.54 297.43 182.04 297.41 182 297.32 181.83 297.15 181.66 296.88 181.41 296.62 181.16 296.56 181.11 296.41 180.96 296.29 180.84 296.1 180.67 295.93 180.5 295.81 180.29 295.79 180.24 295.76 180.19 295.72 180.12 295.7 180.08 295.6 179.88 295.58 179.83 295.51 179.7 295.51 179.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M312.62,204.55a1.68,1.68,0,1,1-.46-2.33,1.69,1.69,0,0,1,.46,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M312.87,204.47a1.68,1.68,0,1,1-.46-2.32,1.69,1.69,0,0,1,.46,2.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "312.62 204.31 312 204.62 311.38 204.92 310.81 204.54 310.24 204.15 310.28 203.47 310.32 202.78 310.94 202.47 311.56 202.16 312.14 202.55 312.72 202.93 312.67 203.62 312.62 204.31 312.62 204.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "312.5 204.23 311.95 204.5 311.39 204.77 310.88 204.43 310.37 204.09 310.41 203.47 310.45 202.86 311 202.59 311.56 202.31 312.07 202.66 312.58 203 312.54 203.61 312.5 204.23 312.5 204.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M312.2,204a.87.87,0,1,1-.24-1.2.87.87,0,0,1,.24,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M312,203.91a.66.66,0,0,1-.91.18.64.64,0,0,1-.18-.91.65.65,0,0,1,.91-.19.66.66,0,0,1,.18.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rear_signal",
    "data-name": "rear signal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M109.89,135.63l1.61,6.58a5,5,0,0,0,2.39.72c1.36,0,4.91.55,7.73-1.3a38.24,38.24,0,0,0,4.25-3.11s-2.35-3.74-5.24-4.67-3.19-.8-3.19-.8l-7.55,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M109.55,135.24l1.64,6.57a5,5,0,0,0,2.45.72c1.39,0,5,.56,7.89-1.29a39.68,39.68,0,0,0,4.34-3.12s-2.4-3.74-5.35-4.66-3.26-.81-3.26-.81l-7.71,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M110.92,135.6l.32,1.14.92,4.2a7.68,7.68,0,0,0,6.07.58,26.25,26.25,0,0,0,6.86-3.49,13.15,13.15,0,0,0-4.23-3.72,8.37,8.37,0,0,0-3.57-.92l-6.37,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M124.7,137.54a12.13,12.13,0,0,0-3.84-3.23,8.37,8.37,0,0,0-3.57-.92l-6.35,2.21c1.35.64,5.16,2.1,11.54,2,.84,0,1.57,0,2.22-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M115.58,141.38l-.83-.59Zm7-5.37Zm-2.39,1.37-.17.12Zm-1.55,1.32,1.55-1.32Zm3.94-2.68h0Zm-7.19,5.44.24-.08Zm-.2-1.64-.18.92.66.47.55-1.07-1-.32Zm9.92-1.87.09.09-.06.12,0,.1-.06,0-.08.07-.06,0-.15.12.14-.32-.49-.44v.44l.16.46-.13.1-.15-.38-.32.36-.14.33.2-.05-.22.14-.16.1-.14.09-.06,0h-1l-.51.77.42-.1-.18.09-.48.22-.19.1,0,0-1.67.05-.54.8-.29.06-.15,0-.86.19-1,0v-.15l-.4.13-.93-.09-.73.26-.42,0h-.3l-.6-.61-1,.11-.31-.18-.49-2.45-.45-2.17-.4-.91,1.06.39-1-.52,1.1-.22,2.39-.83,2.86-1,2.29.45.25.1.28.51,1.12.47.21.08-.18-.46.25.18,0,.09.12.31.83.6-.1-.36.23.23.1.31.61.61-.05-.28.22.2.05.29.67.65h0v-.27l.19.17v.27l.48.44,0-.22.16.17Zm-7.89,3.51,1.71-.05h0l.58-.83-1.7-.13-.59,1Zm.55-1.3.77-1.31-1.24-.36-.68,1.43,1.15.24Zm-.53-2,1.34-1.2-1.23-.51-1.7,1.08,1.59.63Zm-.21-1.92-1.33-.79-1.89.64,1.53,1.25,1.69-1.1Zm-3.58-.05-1.2-.08.7.79,1.85.37-1.35-1.08Zm6.24,4.08.69-1.09-1.63-.29-.75,1.28,1.69.1Zm.89-1.37.91-.92-1.23-.4-1.27,1.06,1.59.26Zm-.27-1.64.07-.07.92-.83-1.19-.45-1.06.93,1.26.42Zm-.48-1.44-.89-.14-.31-.05-1,.59h0l1.18.52,1-.93Zm-2.33,2.43,1.24.34,1.28-1.1-1.19-.4-1.33,1.16Zm-.16-2.23,1.07-.64-.4-.68-1.91.58,1.24.74Zm.49-1.61-.59-.81-2.47.81,1,.64,2.07-.64Zm-6,1.63-.69-.25.23.53,1,.38-.55-.66Zm.1-.2.93,0-.87-.48-.64.13.58.32Zm1.58,0,1.86-.66-1-.65-2,.7,1.13.61Zm6.5-.4v-.17l0-.58-1.6-.1.32.66,1,.14.37,0Zm-.14-1.07-.28-.51-2-.38.52.8,1.74.09Zm3.78,4.69.1-.35-.73-.25-.41.6Zm-.66-1,.33-.52-.68-.51-.7.72,1,.31Zm-1.25-.39.67-.76-.89-.49-1,.86,1.25.39Zm-.28-1.68.06-.72-1.33-.55,0,.79,1.25.48Zm.18,4.18.54-.83-1.58-.17-.66,1.07,1.7-.07Zm-.8-1.29,1.53.15.43-.66-1.07-.34-.89.85Zm1.73-2.91h0l-.3-.21-.56-.39-.08.74.9.51,0-.64Zm.82,1.29v-.49l-.63-.62,0,.6.69.51Zm-.2.9.66.18.25-.22-.55-.46-.36.5Zm.38-1.21v.48l.63.5,0-.35-.66-.63Zm1.3,1.21h0Zm-8.53,1.64.71-1.46-1.56-.66-.23,1.77,1.08.35Zm-.45,1.46,1.09.12.61-1-1.16-.25-.54,1.11Zm-1.14-.34-.49.11-.34.09.61.58.85-.29-.63-.49Zm-1.7-3.72.37,1.7,1.05.32.45.14.24-1.77-2.11-.39Zm-1.21,1.26,1.23.35-.34-1.69-1.27-.48.38,1.82Zm.49,2.43,1.12-.07-.32-1.64-1.23-.36.43,2.07Zm1.45-.1.45-.08.45-.08.18-.94-1.39-.42.31,1.52Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M125.86,138.13h0s-2.4-3.74-5.35-4.66-3.26-.81-3.26-.81L110,135.09c4.39,1.38,12.42,2.57,15.88,3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "rear_wing",
    "data-name": "rear wing"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M115.81,150.39s1.41-1.28,5,.54,13.51,8.6,13.51,8.6a14.09,14.09,0,0,0-9.88.74c-5,2.42-12,8.14-16.68,13.65s-9,11.51-13,13.05-4.64,1.55-4.64,1.55l-.2-1.35s7.2-4.44,9.82-9.08l.72-1.25-.38-.24a.62.62,0,0,1-.19-.85l1.36-2.16a.62.62,0,0,1,.85-.2l.25.16,4.1-7-.16-.08a.67.67,0,0,1-.31-.91l1.25-2.53a.68.68,0,0,1,.91-.31l.42.21,1.24-2.13a.6.6,0,0,1-.09-.33V157a.65.65,0,0,1,.65-.64h2c2-3.48,3.47-5.93,3.47-5.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M118.52,150.08c.18,0,.36.08.55.14-.91,1.55-2.18,3.59-3.6,5.81-3,4.69-5.57,8.4-5.74,8.29s2.12-4,5.12-8.68c1.38-2.15,2.67-4.09,3.67-5.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 108.55,
    y: 156.97,
    width: 1.09,
    height: 3.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M110.38,158.63h2.13l.9-1.45h-3a.37.37,0,0,0-.37.37v.72a.37.37,0,0,0,.37.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M107.22,163.77l.88.43a.13.13,0,0,0,.16,0l.1-.21a.12.12,0,0,0,0-.16l-.89-.43a.13.13,0,0,0-.16.05l-.1.21a.12.12,0,0,0,.06.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M101.15,174.63l.89.43a.13.13,0,0,0,.16-.05l.1-.21a.12.12,0,0,0-.06-.16l-.89-.43a.11.11,0,0,0-.15.06l-.1.2a.12.12,0,0,0,.05.16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-133",
    cx: 121.88,
    cy: 156.17,
    r: 2.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M124.38,156.17a2.5,2.5,0,0,0-2.5-2.5h-.25a2.5,2.5,0,0,1,0,5l.25,0a2.5,2.5,0,0,0,2.5-2.5Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "134.68 130.81 135.63 131.01 139.17 131.63 141.31 131.53 142.02 131.28 141.82 131.55 141.62 133.88 141.61 134.3 141.61 134.58 141.54 134.63 141.3 134.8 141.14 134.83 140.59 134.94 140.29 134.94 139.18 134.97 138.59 134.95 138 134.93 137.91 134.92 137.73 134.92 136.79 134.92 136.09 134.87 135.31 134.8 135.01 134.78 135.02 133.49 135.02 133.29 134.81 130.96 134.68 130.81 134.68 130.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M110,125c.29-1.11,1.56-.9,3.82-1,5.68-.21,8-.74,13.13.81,3.14.94,15.11,3.4,16.08,4.12.53.4,1.28,1.42-.44,2.18-2.92,1.3-7.9-.32-11-1l-5-1,1.75,3.33c-.63.59-2,.42-2.88.44-1,0-3.56.21-4.45-.35-1.77-1.13-10.71-6.54-11-7.14l0-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M110,125a1.09,1.09,0,0,1,.16-.38c3.45.62,13,2.34,15.78,3.07a105.11,105.11,0,0,0,14.75,2.43c2.35,0,3-1.08,1.93.19s-4.14.89-6.64.5c-2.2-.33-21.21-4.54-26-5.59l0-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M126.61,129.28l-11.77-2.36,6.48,5.78a14.9,14.9,0,0,0,4.07.18c.87,0,2.25.15,2.88-.44l-1.66-3.16Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mirror"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M251,93.05ZM238.53,79.71c-3.42,1.09-5.2-14.24-.94-13.15,5.17,1.34,8.07,2.88,10.42,8.18,1.13,2.54,1.21,17,3.21,18.31,3.27,2.23.92,4.78-4.19,2.2-3.46-1.74-.71-3.25.36-3.29.63-3.13-2-13.2-1.85-13.35l-1-.91c-1,.2-4.76,1.58-6,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M235.14,72.73a19.37,19.37,0,0,1,7.28-.13c2.34.43,4.12.85,4.74.44-2.21-4-5-5.3-9.57-6.48-2.06-.52-2.7,2.75-2.45,6.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "light"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M278.14,130.75s5.72,4.82,7.75,6.77,5,5.94,5.87,6.84a8.28,8.28,0,0,0,4,1.89c1.41.29,8.18,1.19,8.18,1.19s-16.58-18.93-25.82-16.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M278.22,131.28s5.54,4.67,7.5,6.56,4.87,5.75,5.68,6.62a8,8,0,0,0,3.89,1.83c1.37.27,7.92,1.15,7.92,1.15s-16-18.33-25-16.16Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M292.33,136.72c3.8,3.15,5.7,7,4.23,8.59s-4.4-.51-8.21-3.67-7.05-6.18-5.58-7.77,5.75-.31,9.56,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M287.12,141.23c-3.68-3.1-6.87-5.45-5.28-7.06s5.85-.41,9.54,2.69,5.38,6.94,3.8,8.55-4.37-1.07-8.06-4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M295.75,143.46a2.35,2.35,0,0,1-.57,1.95c-1,1-2.92.92-5.12,0l1.75-.4c2.1-.49,1-1.55,2.1-1.86a3.1,3.1,0,0,1,1.84.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M284,133.45c2,0,4.87,1.26,7.43,3.42a14.75,14.75,0,0,1,3.74,4.55l-.47.35s-.27-1.65-2.94-1.18-3.64,1.34-4.58,1.34-1.28-.25-2.3-1.61,0-2.33.66-1.64,1,2,2.14,1.31,2.91-1.31,2.47-2.23-.92-1.64-2.83-1.12-2.69,1.42-2.84.86-.09-.66-1.11-.3a1.34,1.34,0,0,0-.8,1.51s-1.09-1.59-.66-2.74a11.71,11.71,0,0,1,2.09-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M287.86,135.36a5.48,5.48,0,0,0-2.89.71c-1.46.82-1.58,1.72-1.58,1.72s-1.18-.89-1-1.8,1.75-1.78,1.75-1.78l3.68,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M290.71,140.42a2.59,2.59,0,0,1-1.72.06c-1-.29-.49-1.27-1.36-.89s-.81.57-1.53-.27-1.25.27-.83.78,1.66,0,2.07.69.37,1.64,1.67,1.28a2.65,2.65,0,0,0,1.7-1.65Zm3.81,3a15.48,15.48,0,0,0-4-.43c-1.4.17-.92,1.43-.19,1.3s4.21-.87,4.21-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M295.29,140.27c.74.66,1.45,1.07,1.6.9s-.33-.83-1.07-1.49-1.45-1.07-1.6-.91S294.55,139.6,295.29,140.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M281.06,131.92c-.24.39-.26.82,0,1s.59-.08.83-.47.25-.82,0-1S281.3,131.53,281.06,131.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M298.55,143.93c4.17,1.84,7.36,3.78,7.12,4.32s-3.82-.51-8-2.36-7.35-3.78-7.11-4.33S294.38,142.08,298.55,143.93Z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "cargo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "COLOUR-2",
    "data-name": "COLOUR",
    className: "cls-72",
    d: "M87.09,131.86H160a14.35,14.35,0,0,0,14.31-14.31h0A14.36,14.36,0,0,0,160,103.23h-2c-.6-5.61-2.08-18.87-3.12-22.46-1.33-4.58-2.29-9.66-11.59-9.54S113,72.8,101.88,75.34s-15.58,3.5-17,10.87a145.69,145.69,0,0,0-1.78,17l-1.19.7c.44,9.21,2.16,24.51,3.33,26.24s1.09,1.21,1.88,1.69Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "signals"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M91.82,78c-4,1.55-6.08,3.66-7,8.2a145.69,145.69,0,0,0-1.78,17l-1.19.7c.09,1.92.24,4.1.43,6.37l4,0s1.15-.3,1.7-2.25c.46-1.62,3-22.94,3.81-30.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M87.7,91.17c-1,5.76-2.37,10.34-3,10.22s-.4-4.88.61-10.65,2.37-10.34,3-10.23S88.71,85.4,87.7,91.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M89,82.46a7.41,7.41,0,0,1-1.79-.11A6.59,6.59,0,0,1,89,82.23a6.64,6.64,0,0,1,1.8.12,7.47,7.47,0,0,1-1.8.11Zm.18-1.15a6.45,6.45,0,0,1-1.8-.13,7.22,7.22,0,0,1,1.8-.12,7.1,7.1,0,0,1,1.79.12,6.35,6.35,0,0,1-1.79.13Zm-4.26,27.63a7.22,7.22,0,0,0-1.8.12,6.45,6.45,0,0,0,1.8.13,6.35,6.35,0,0,0,1.79-.13,7.1,7.1,0,0,0-1.79-.12Zm.18-1.15a7.47,7.47,0,0,0-1.8.11,7.47,7.47,0,0,0,1.8.11,7.41,7.41,0,0,0,1.79-.11,7.41,7.41,0,0,0-1.79-.11Zm.17-1.15a7.76,7.76,0,0,0-1.79.1,7.76,7.76,0,0,0,1.79.1,7.81,7.81,0,0,0,1.8-.1,7.81,7.81,0,0,0-1.8-.1Zm.18-1.15a8.94,8.94,0,0,0-1.79.09,8.94,8.94,0,0,0,1.79.09,9.09,9.09,0,0,0,1.8-.09,9.09,9.09,0,0,0-1.8-.09Zm.18-1.15a9.6,9.6,0,0,0-1.8.08,20.29,20.29,0,0,0,3.6,0,9.6,9.6,0,0,0-1.8-.08Zm.18-1.16a13,13,0,0,0-1.8.07,20.18,20.18,0,0,0,3.59,0,12.93,12.93,0,0,0-1.79-.07ZM86,102a14,14,0,0,0-1.79.06,11.29,11.29,0,0,0,1.79.07,11.37,11.37,0,0,0,1.8-.07A14.14,14.14,0,0,0,86,102Zm.18-1.15a15.38,15.38,0,0,0-1.79.05,15.38,15.38,0,0,0,1.79,0,15.63,15.63,0,0,0,1.8,0,15.63,15.63,0,0,0-1.8-.05Zm.18-1.15c-1,0-1.8,0-1.8,0s.81,0,1.8,0,1.79,0,1.79,0-.8,0-1.79,0Zm.18-1.15c-1,0-1.8,0-1.8,0s.8,0,1.8,0,1.79,0,1.79,0-.8,0-1.79,0Zm.18-1.15c-1,0-1.8,0-1.8,0s.8,0,1.8,0,1.79,0,1.79,0-.81,0-1.79,0Zm.17-1.16h-1.8s.81,0,1.8,0,1.8,0,1.8,0Zm.18-1.15h0ZM87.25,94c-1,0-1.8,0-1.8,0H89s-.8,0-1.79,0Zm.18-1.15c-1,0-1.8,0-1.8,0s.8,0,1.8,0,1.79,0,1.79,0-.8,0-1.79,0Zm.17-1.15c-1,0-1.8,0-1.8,0s.81,0,1.8,0,1.8,0,1.8,0-.81,0-1.8,0Zm.18-1.15c-1,0-1.8,0-1.8,0a17.27,17.27,0,0,1,1.8,0,17.27,17.27,0,0,1,1.8,0s-.81,0-1.8,0ZM88,89.37c-1,0-1.8,0-1.8-.05a26.88,26.88,0,0,1,3.59,0s-.8.05-1.79.05Zm.18-1.16a12.22,12.22,0,0,1-1.8-.06,26.88,26.88,0,0,1,3.59,0,12.13,12.13,0,0,1-1.79.06Zm.17-1.15A11.29,11.29,0,0,1,86.52,87a11.29,11.29,0,0,1,1.79-.07,11.48,11.48,0,0,1,1.8.07,11.48,11.48,0,0,1-1.8.07Zm.18-1.15a10.74,10.74,0,0,1-1.8-.08,10.74,10.74,0,0,1,1.8-.08,10.57,10.57,0,0,1,1.79.08,10.57,10.57,0,0,1-1.79.08Zm.18-1.15a9,9,0,0,1-1.8-.09,9,9,0,0,1,1.8-.09,8.94,8.94,0,0,1,1.79.09,8.94,8.94,0,0,1-1.79.09Zm.18-1.15a8.54,8.54,0,0,1-1.8-.1,7.81,7.81,0,0,1,1.8-.1,7.76,7.76,0,0,1,1.79.1,8.48,8.48,0,0,1-1.79.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M173,121.45a13.63,13.63,0,0,0-14.87-17.37,13.87,13.87,0,0,1,7.79,2A15.41,15.41,0,0,1,173,121.45Zm-27.17-50.1a20.3,20.3,0,0,0-2.55-.12c-9.3.13-30.31,1.57-41.42,4.11-10.56,2.41-15.12,3.4-16.79,9.81,1.87-2.54,7-6.16,21-8.48,23.6-3.89,39.79-4.5,42.69-1.83,1.35,1.24,1-1.07-3-3.49ZM82,106.62c.61,9.24,2.12,22,3.18,23.55.93,1.37,1.07,1.33,1.49,1.49a12.09,12.09,0,0,0-1-4.08c-2-5.31-1.77-19.92-1.69-22,.06-1.48-1.26,0-2,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M92.49,78.68l-.66.27c-.93,7.94-3.26,27.53-3.7,29.08-.55,2-1.7,2.25-1.7,2.25l-3.51,0L83,111l4,0s1.15-.3,1.7-2.25c.46-1.62,3-22.94,3.81-30.08Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-142",
    transform: "translate(91.07 113.33) scale(1.1 1)"
  }, "T", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-143",
    x: 4.61,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-144",
    x: 10.39,
    y: 0
  }, "\u015F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-145",
    x: 14.45,
    y: 0
  }, "\u0131ma"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M143.65,101.58v12.25h0c.26,0,.53,0,.79,0s.21-.07.23-.23l.3-2.48c.19-1.61.37-3.23.59-4.83a14,14,0,0,1,.42-1.6c.56,0,1.11,0,1.66.09,1.07.08,2.14.15,3.2.26a6.94,6.94,0,0,1,3.46,1.16,6.82,6.82,0,0,1,2.12,2.79,35.32,35.32,0,0,1,1.92,5.58.59.59,0,0,1,0,.32.84.84,0,0,0,.11.84c0,.06.07.13.14.26a7.53,7.53,0,0,1-.56.57.44.44,0,0,1-.25.11c-.41,0-.82,0-1.22,0a.26.26,0,0,0-.2.15,1.95,1.95,0,0,1-3.86,0,1.12,1.12,0,0,0-.05-.13h-8.12a2.74,2.74,0,0,1-.71,1.33v3.56H162v-20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M157,114.86h.52c-.28-.5-.53-.93-.78-1.36s-.19-.34-.55-.14l.66,1.39A.22.22,0,0,0,157,114.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.36,116.69h8.12a1.12,1.12,0,0,1,.05.13,1.95,1.95,0,0,0,3.86,0,.26.26,0,0,1,.2-.15c.4,0,.81,0,1.22,0a.44.44,0,0,0,.25-.11,7.53,7.53,0,0,0,.56-.57c-.07-.13-.1-.2-.14-.26a.84.84,0,0,1-.11-.84.59.59,0,0,0,0-.32,35.32,35.32,0,0,0-1.92-5.58,6.82,6.82,0,0,0-2.12-2.79,6.94,6.94,0,0,0-3.46-1.16c-1.06-.11-2.13-.18-3.2-.26-.55,0-1.1-.06-1.66-.09a14,14,0,0,0-.42,1.6c-.22,1.6-.4,3.22-.59,4.83l-.3,2.48c0,.16-.07.24-.23.23s-.53,0-.79,0h0l-.6,2.6C143.38,116.11,143.51,116.68,144.36,116.69Zm10.11.72a1.2,1.2,0,0,1,0-2.38,1.1,1.1,0,0,1,1,1.18A1.11,1.11,0,0,1,154.47,117.41ZM154.23,107a.29.29,0,0,1,.31,0,5.9,5.9,0,0,1,1.25,1.73c.34.66.62,1.36.93,2.05,0,0,0,.1.06.19s-.1.16-.16.18a.24.24,0,0,1-.22-.09,3.32,3.32,0,0,1-.2-.47,9.46,9.46,0,0,0-1.92-3.25C154.17,107.24,154.11,107.1,154.23,107Zm-3-1.32a.56.56,0,0,1,.16-.2,6.21,6.21,0,0,1,2.11.72c.07,0,.09.2.13.31s-.21.13-.28.1a6.73,6.73,0,0,0-1.92-.66C151.27,105.92,151.16,105.85,151.2,105.68Zm-5.39,3.38c.1-.84.2-1.67.31-2.51,0-.1,0-.19,0-.32l2.07.13c.06,0,.13.13.16.22.2.57.37,1.15.59,1.71a2.27,2.27,0,0,0,1.44,1.4c1.93.66,3.84,1.38,5.76,2.06a2.37,2.37,0,0,0,.75.08.25.25,0,0,1,.28.22c.23.83.49,1.65.73,2.47a.77.77,0,0,1,0,.37c-.11.32-.17.76-.39.92s-.6,0-.91.06h-.2a2.51,2.51,0,0,0-.72-1.42,1.89,1.89,0,0,0-3.14,1c-.06.22-.15.27-.34.26l-5.29-.23a.46.46,0,0,1-.29-.11c-.44-.37-.89-.74-1.32-1.14a.44.44,0,0,1-.13-.33C145.4,112.28,145.61,110.67,145.81,109.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M146.66,115.36a.46.46,0,0,0,.29.11l5.29.23c.19,0,.28,0,.34-.26a1.89,1.89,0,0,1,3.14-1,2.51,2.51,0,0,1,.72,1.42h.2c.31,0,.69.1.91-.06s.28-.6.39-.92a.77.77,0,0,0,0-.37c-.24-.82-.5-1.64-.73-2.47a.25.25,0,0,0-.28-.22,2.37,2.37,0,0,1-.75-.08c-1.92-.68-3.83-1.4-5.76-2.06a2.27,2.27,0,0,1-1.44-1.4c-.22-.56-.39-1.14-.59-1.71,0-.09-.1-.21-.16-.22l-2.07-.13c0,.13,0,.22,0,.32-.11.84-.21,1.67-.31,2.51-.2,1.61-.41,3.22-.6,4.83a.44.44,0,0,0,.13.33C145.77,114.62,146.22,115,146.66,115.36Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M154.46,115a1.2,1.2,0,1,0,1,1.18A1.1,1.1,0,0,0,154.46,115Zm0,2a.78.78,0,0,1-.71-.8.76.76,0,0,1,.7-.8.81.81,0,0,1,0,1.6Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M156.2,110.6a3.32,3.32,0,0,0,.2.47.24.24,0,0,0,.22.09c.06,0,.11-.12.16-.18s0-.14-.06-.19c-.31-.69-.59-1.39-.93-2.05a5.9,5.9,0,0,0-1.25-1.73.29.29,0,0,0-.31,0c-.12.1-.06.24.05.35A9.46,9.46,0,0,1,156.2,110.6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M151.4,106a6.73,6.73,0,0,1,1.92.66c.07,0,.19-.07.28-.1s-.06-.27-.13-.31a6.21,6.21,0,0,0-2.11-.72.56.56,0,0,0-.16.2C151.16,105.85,151.27,105.92,151.4,106Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M154.45,115.42a.76.76,0,0,0-.7.8.78.78,0,0,0,.71.8.81.81,0,0,0,0-1.6Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-46",
    cx: 154.77,
    cy: 115.77,
    r: 2.72
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M154.73,113.56a2.13,2.13,0,1,0,2.13,2.12A2.13,2.13,0,0,0,154.73,113.56Zm0,3.09a1,1,0,1,1,1-1A1,1,0,0,1,154.73,116.65Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M157.51,112.33l.83,1.46a5,5,0,0,1-.56,0,.2.2,0,0,1-.15-.11c-.24-.49-.48-1-.71-1.48C157.3,112,157.3,112,157.51,112.33Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.27,113.3l-3.25.31h4.29v1l-6.75.5h6.75v1l-8.48.59h11.88s0,0,0,0h3.58s0,0,0,0h2.43a.57.57,0,0,0,.51.56h2.61a.57.57,0,0,0,.51-.56h2.91v-2.44h0v-.94Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-46",
    cx: 134.32,
    cy: 116.28,
    r: 2.43
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-46",
    cx: 134.36,
    cy: 115.96,
    r: 2.47
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.32,114a1.94,1.94,0,1,0,1.94,1.94A1.93,1.93,0,0,0,134.32,114Zm0,2.81a.88.88,0,1,1,.88-.87A.87.87,0,0,1,134.32,116.76Z"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-148",
    transform: "matrix(1.1, -0.11, 0.1, 1, 126.24, 113.52)"
  }, "c\u0131m")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAraclar13);
export default __webpack_public_path__ + "static/media/araclar-13.cacdd9368beb9461b3582379ee7f1bd8.svg";
export { ForwardRef as ReactComponent };